import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../components/services/api";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { SUM_FREETIME } from "../components/sum";
import { el } from "date-fns/locale";
import ClearIcon from "@mui/icons-material/Clear";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddSaleOrder() {
  const history = useHistory();
  const { id } = useParams();

  const [dateetd, setEtd] = useState("");
  const [closing_date, setClosingdate] = useState("");
  const classes = useStyles();
  const [bookingData, setBookingData] = useState();

  const [selectDialog, setSelectedDialog] = useState();
  const [numberOfTrucks, setNumberOfTrucks] = useState("");

  const [voyIn, setVoyIn] = useState([]);
  const [voyOut, setVoyOut] = useState([]);
  const [openVoyIn, setOpenVoyIn] = useState(false);
  const [openVoyOut, setOpenVoyOut] = useState(false);

  const [DetDemDisable, setDetDemDisable] = useState(false);
  const [ComDisable, setComDisable] = useState(false);
  const [com_caluateSelect, setCom_caluateSelect] = useState(false);

  /////////////////////////////////State_Data_Master////////////////////////////////////////
  const [forwarderData, setForwarderData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [commodityData, setCommodityData] = useState([]);
  const [quotationData, setQuotationData] = useState([]);
  const [containerData, setContainerData] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [linersData, setLinersData] = useState([]);
  const [freightForwarderData, setFreightForwarderData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [terminalData, setTerminalData] = useState([]);
  const [podTerminalData, setPodTerminalData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [transshipmentData, setTransshipmentData] = useState([]);
  const [incotermData, setIncotermData] = useState([]);
  const [termsData, setTermsData] = useState([]);
  const [depotsData, setDepotsData] = useState([]);
  const [factoryData, setFactoryData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [venderData, setVenderData] = useState([]);
  const [inspectionStationData, setInspectionStationData] = useState([]);
  const [transportationData, setTransportationData] = useState(null);

  ///////////////////////////////State_ID//////////////////////////////////////////////
  const [forwardingId, setForwardingId] = useState("");
  const [quotationId, setQuotationID] = useState("");
  const [customerID, setCustomerID] = useState("");

  ////////////////////////////////////State_table////////////////////////////////////////
  const [isEdit, setIsEdit] = useState({ status: false, id: null });
  const [rowMTCACS, setRowMTCACS] = useState([]);
  const [rowStuffing, setRowStuffing] = useState([]);
  const [addTruck, setAddTruck] = useState(null);
  const [addVender, setAddVender] = useState(null);
  const [editTruck, setEditTruck] = useState(null);
  const [editNumberOfTrucks, setEditNumberOfTrucks] = useState(null);
  const [editVender, setEditVender] = useState(null);
  const [addPUD, setAddPUD] = useState(null);
  const [addFactory, setAddFactory] = useState(null);
  const [addQTT, setAddQTT] = useState(null);
  const [addRD, setAddRD] = useState(null);
  const [isEditS, setIsEditS] = useState({ status: false, id: null });
  const [editPUD, setEditPUD] = useState(null);
  const [editFactory, setEditFactory] = useState(null);
  const [editRD, setEditRD] = useState(null);
  const [editQTT, setEditQTT] = useState(null);
  const [terminalsData, setTerminalsData] = useState([]);
  const [terminalsListData, setTerminalsListData] = useState([]);

  //////////////////////////////////// fetch Master ///////////////////////////////////////

  const getMasterCountry = async () => {
    const res = await api.get(`api/master/country`);
    const data = await res.data;
    if (res.meta.status === true) {
      setCountryData(data.data);
    }
  };
  const getMasterGroup = async () => {
    const res = await api.get(`api/master/group`);
    const data = await res.data;
    if (res.meta.status === true) {
      setGroupData(data.data);
    }
  };

  const getCustomerList = async () => {
    const params = {
      cusType: 2,
    };
    try {
      const res = await api.post("api/customer/list", params);
      const data = await res.data;
      if (res.meta.status === true) {
        setCustomerData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getForwarderData = async () => {
    const params = {
      cusType: 1,
    };
    try {
      const res = await api.post("api/customer/list", params);
      const data = await res.data;
      if (res.meta.status === true) {
        setForwarderData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getQuotation = async (props, data) => {
    if (data !== null && data !== undefined) {
      const id = {
        id: data.CustomerId,
      };
      setCustomerID(data.CustomerId);
      try {
        const res = await api.post("api/master/referquotation", id);
        const data = await res.data;

        if (res.meta.status === true) {
          setQuotationData(data.data);
        }
      } catch (e) {
        console.log(e);
      }
    }
  };
  const getFreightForwarder = async () => {
    try {
      const res = await api.get("api/master/freightforwarder");
      const data = await res.data;
      if (res.meta.status === true) {
        setFreightForwarderData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getMasterPackage = async () => {
    try {
      const res = await api.get("api/master/package");
      const data = await res.data;
      if (res.meta.status === true) {
        setPackageData(data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getFactoryList = async () => {
    try {
      const res = await api.get("api/factory/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setFactoryData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getCompanyList = async () => {
    try {
      const res = await api.get("api/company/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCompanyData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getVenderList = async () => {
    try {
      const res = await api.get("api/vender/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setVenderData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getTransshipment = async () => {
    try {
      const res = await api.get("api/transshipment/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setTransshipmentData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getCommodity = async () => {
    try {
      const res = await api.get("api/commodity/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCommodityData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getContaier = async () => {
    try {
      const res = await api.get("api/container/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setContainerData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLiners = async () => {
    try {
      const res = await api.get("api/liners/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLinersData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getDepots = async () => {
    try {
      const res = await api.get("api/depots/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setDepotsData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getTerminal = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setTerminalData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getTerms = async () => {
    try {
      const res = await api.get("api/terms/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setTermsData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getIncoTerms = async () => {
    try {
      const res = await api.get("api/inco/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setIncotermData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getInspectionStation = async () => {
    try {
      const res = await api.get("api/inspectionStation/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setInspectionStationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getPodTerminal = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setPodTerminalData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getMasterTerminal = async () => {
    const res = await api.get(`api/terminal/list`);
    const data = await res.data;
    setTerminalsListData(data);
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocationData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getMasterCountry();
    getMasterGroup();
    getCustomerList();
    getForwarderData();
    getFreightForwarder();
    getMasterPackage();
    getFactoryList();
    getTransshipment();
    getCommodity();
    getContaier();
    getLiners();
    getDepots();
    getTerminal();
    getTerms();
    getIncoTerms();
    getPodTerminal();
    getLocation();
    getCompanyList();
    getInspectionStation();
    getVenderList();
    getMasterTerminal();
  }, []);
  const getBookingData = async () => {
    const res = await api.get(`api/saleorder/detail/bookinginfo/${id}`);
    const data = await res.data;
    console.log(data);
    if (res.meta.status === true) {
      setBookingData(data);
      getQuotation(undefined, {CustomerId:data?.CustomerId});
      // setSaleOrderNo(data.SaleOrderNo)
      // setStatusSelect_data(data.SaleOrderStatus)
      setCustomerID(data.CustomerId);
      // setCustomerID(data);
    }
  };
  const getTransportation = async () => {
    const res = await api.get(`api/saleorder/detail/transportation/${id}`);
    const data = await res.data;
    if (res.meta.status === true) {
      setTransportationData(data);
      setRowMTCACS(
        data.MtCntr.map((x, i) => ({
          id: data.MtCntr.slice(-1)[0]?.id
            ? data.MtCntr.slice(-1)[0]?.id + 1
            : i + 1,
          Truck: x.TruckRequest,
          ...x,
        }))
      );
      if (factoryData.length > 0) {
        setRowStuffing(
          data.StuffingPlan.map((x, i) => ({
            id: data.StuffingPlan.slice(-1)[0]?.id
              ? data.StuffingPlan.slice(-1)[0]?.id + 1
              : i + 1,
            Factory: factoryData?.filter(
              (y) => x.FactoryId === y?.FactoryId
            )[0],
            PUD: x.PickupDate,
            RD: x.ReturnDate,
            QTT: x.Quantity,
          }))
        );
      }
    }
  };
  useEffect(() => {
    if (id) {
      getBookingData();
      getTransportation();
    }
  }, []);

  console.log(
    forwarderData?.find((x) => x?.CustomerId === bookingData?.ForwardingId)
  );
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Sale Order
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="none" color="inherit">
                  Customer Support
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  href="/CustomerSupport/SaleOrder"
                >
                  Sale Order
                </Link>
                <Typography color="text.primary">Add Sale Order</Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
          <Formik
            enableReinitialize
            initialValues={{
              TripType: bookingData?.TripType || "Round Trip",
              TripDirection: bookingData?.TripDirection || "",
              ServiceType: bookingData?.ServiceType || "",
              forwarding: bookingData?.ForwardingId
                ? forwarderData?.find(
                    (x) => x?.CustomerId === bookingData?.ForwardingId
                  )
                : null,
              forwardingId: bookingData?.ForwardingId || "",
              customer_name: bookingData?.CustomerId
                ? customerData?.find(
                    (x) => x?.CustomerId === bookingData?.CustomerId
                  )
                : null,
              customer_id: bookingData?.CustomerId || "",
              quotation_no: bookingData?.QuotationId || null,
              shipper_ref_no: bookingData?.ShipperRefNo || "",
              shipper_si_no: "",
              shipper_invoice_no: bookingData?.ShipperInvoiceNo || "",
              detail_quotation: "",
              volume_container: bookingData?.ContainerTypeId || null,
              volume_quantity: bookingData?.Quantity || "",
              commodity: bookingData?.CommodityId
                ? bookingData?.CommodityId
                : "",
              packaging: bookingData?.PackageId || null,
              booking_no: bookingData?.BookingNo || "",
              liners:
                linersData?.length > 0
                  ? linersData?.find(
                      (x) => x?.LinersId === bookingData?.LinersId
                    )
                  : null,
              freight_forwarder:
                freightForwarderData.length > 0
                  ? freightForwarderData?.find(
                      (x) => x?.FreightId === bookingData?.FreightForwarderId
                    )
                  : null,
              etd_pol: bookingData?.ETDPOLDate || null,
              etd_time: bookingData?.ETDPOLTime || null,
              closing_date: bookingData?.ClosingDate || null,
              closing_time: bookingData?.ClosingTime || null,
              pol_conuntry:
                countryData?.length > 0
                  ? countryData?.find(
                      (x) => x?.CountryId === bookingData?.POLCountryId
                    )
                  : null,
              pol_terminal:
                locationData?.length > 0
                  ? locationData?.find(
                      (x) => x?.LocationId === bookingData?.POLLocationId
                    )
                  : null,
              pod_conuntry:
                countryData?.length > 0
                  ? countryData?.find(
                      (x) => x?.CountryId === bookingData?.PODCountryId
                    )
                  : null,
              pod_terminal:
                locationData?.length > 0
                  ? locationData?.find(
                      (x) => x?.LocationId === bookingData?.PODLocationId
                    )
                  : null,
              eta_pod: bookingData?.ETAPODDate || null,
              eta_time: bookingData?.ETAPODTime || null,
              det: bookingData?.DET || "",
              dem: bookingData?.DEM || "",
              com: bookingData?.COM || "",
              CountingType: bookingData?.CountingType || "",
              c_det: bookingData?.COMDET || "",
              c_dem: bookingData?.COMDEM || "",

              choice_com_calculate: "",

              first_pickup: bookingData?.FirstPickupDate || null,
              actual_pickup: bookingData?.ActualPickupDate || null,

              return_date: null,
              actual_return_date: null,

              cut_off_VGM: bookingData?.CutOffVGMDate || null,
              cut_off_VGM_time: bookingData?.CutOffVGMTime || null,

              cut_off_SI: bookingData?.CutOffSIDate || null,
              cut_off_SI_time: bookingData?.CutOffSITime || null,

              first_vissel: bookingData?.FeederVessel || "",
              first_vissel_transshipment:
                bookingData?.FeederTransshipmentId || null,
              second_vissel: bookingData?.MotherVessel || "",
              second_vissel_transshipment:
                bookingData?.MotherTransshipmentId || null,
              third_vissel: bookingData?.ThirdVessel || "",
              third_vissel_transshipment:
                bookingData?.ThirdTransshipmentId || null,
              inco_terms: bookingData?.IncotermsId || null,
              freight_terms: bookingData?.FreightTermsId || null,
              container_require_select:
                transportationData?.ContainerStockType || "",
              grade: transportationData?.ContainerGrade || "",
              apply_layer_plastic_sheet:
                transportationData?.ContainerApplyPlasticSheet || "",
              depots:
                depotsData?.length > 0
                  ? depotsData?.find(
                      (x) => x?.DepotsId === transportationData?.DepotsId
                    )
                  : null,
              transport_InBound:
                transportationData?.InboundTransportGroupId || "",
              InBoundGateOut:
                locationData.length > 0
                  ? locationData?.find(
                      (x) =>
                        x?.LocationId === transportationData?.InboundGateOutId
                    )
                  : null,
              container_gender_Inbound:
                transportationData?.InboundContainerGender || "",
              transport_OutBound:
                transportationData?.OutboundTransportGroupId || "",
              OutBoundGateOut:
                locationData.length > 0
                  ? locationData?.find(
                      (x) =>
                        x?.LocationId === transportationData?.OutboundGateOutId
                    )
                  : null,
              container_gender_OutBound:
                transportationData?.OutboundContainerGender || "",
              voyIn: transportationData?.InboundVoyNo || "",
              ETD_Gate_Out_Inbound:
                transportationData?.InboundETDGateOut || null,
              ETA_Gate_In_Inbound: transportationData?.InboundETAGateIn || null,
              InboundQuantity: transportationData?.InboundQuantity || "",
              voyIn_2: transportationData?.InboundVoyNo_2 || "",
              ETD_Gate_Out_Inbound_2:
                transportationData?.InboundETDGateOut_2 || null,
              ETA_Gate_In_Inbound_2:
                transportationData?.InboundETAGateIn_2 || null,
              InboundQuantity_2: transportationData?.InboundQuantity_2 || "",
              voyIn_3: transportationData?.InboundVoyNo_3 || "",
              ETD_Gate_Out_Inbound_3:
                transportationData?.InboundETDGateOut_3 || null,
              ETA_Gate_In_Inbound_3:
                transportationData?.InboundETAGateIn_3 || null,
              InboundQuantity_3: transportationData?.InboundQuantity_3 || "",
              first_Laden_Date: bookingData?.FirstLadenDate || null,
              actual_Laden_Date: bookingData?.ActualLadenDate || null,
              voyOut: transportationData?.OutboundVoyNo || "",
              ETD_Gate_Out_OutBound:
                transportationData?.OutboundETDGateOut || null,
              ETA_Gate_In_OutBound:
                transportationData?.OutboundETAGateIn || null,
              OutboundQuantity: transportationData?.OutboundQuantity || "",
              voyOut_2: transportationData?.OutboundVoyNo_2 || "",
              ETD_Gate_Out_OutBound_2:
                transportationData?.OutboundETDGateOut_2 || null,
              ETA_Gate_In_OutBound_2:
                transportationData?.OutboundETAGateIn_2 || null,
              OutboundQuantity_2: transportationData?.OutboundQuantity_2 || "",
              voyOut_3: transportationData?.OutboundVoyNo_3 || "",
              ETD_Gate_Out_OutBound_3:
                transportationData?.OutboundETDGateOut_3 || null,
              ETA_Gate_In_OutBound_3:
                transportationData?.OutboundETAGateIn_3 || null,
              OutboundQuantity_3: transportationData?.OutboundQuantity_3 || "",
              phyto_cert: transportationData?.PhytoCert || "",
              PhytoCertInspectionStaionId:
                transportationData?.PhytoCertInspectionStaionId || "",
              fumigation: transportationData?.Fumigation || "",
              FumigationInspectionStaionId: "",
              phyto_cert_remark: transportationData?.PhytoCertRemark || "",
              fumigation_remark: transportationData?.FumigationRemark || "",
              FumigationPQNo:
                transportationData?.FumigationInspectionStaionId || "",
              TerminalName: transportationData?.TerminalName
                ? { TerminalName: transportationData?.TerminalName }
                : null,
            }}
            onSubmit={(values, { setSubmitting }) => {
              const body = {
                SaleOrderId: null,
                ForwardingId: values.forwarding?.CustomerId,
                CustomerId: values.customer_name?.CustomerId,
                // ForwardingId: values.forwarding,
                // CustomerId: values.customer_name,
                QuotationId: values.quotation_no,
                TripType: values.TripType || "Round Trip",
                TripDirection: values.TripDirection || null,
                ServiceType: values.ServiceType || null,
                ShipperRefNo: values.shipper_ref_no,
                ShipperInvoiceNo: values.shipper_invoice_no,
                ContainerTypeId: values.volume_container,
                Quantity: values.volume_quantity,
                CommodityId: values.commodity,
                PackageId: values.packaging,
                BookingNo: values.booking_no,
                LinersId: values.liners?.LinersId || null,
                FreightForwarderId: values.freight_forwarder?.FreightId || null,
                ETDPOLDate: values.etd_pol,
                ETDPOLTime: values.etd_time,
                ClosingDate: values.closing_date,
                ClosingTime: values.closing_time,
                POLCountryId: values.pol_conuntry?.CountryId || null,
                POLLocationId: values.pol_terminal?.LocationId || null,
                PODCountryId: values.pod_conuntry?.CountryId || null,
                PODLocationId: values.pod_terminal?.LocationId || null,
                ETAPODDate: values.eta_pod,
                ETAPODTime: values.eta_time,
                DET: values.det,
                DEM: values.dem,
                COM: values.com,
                CountingType: values.CountingType,
                COMDET: values.c_det,
                COMDEM: values.c_dem,
                CutOffVGMDate: values.cut_off_VGM,
                CutOffVGMTime: values.cut_off_SI_time,
                CutOffSIDate: values.cut_off_SI,
                CutOffSITime: values.cut_off_SI_time,
                FeederVessel: values.first_vissel,
                FeederTransshipmentId: values.first_vissel_transshipment,
                MotherVessel: values.second_vissel,
                MotherTransshipmentId: values.second_vissel_transshipment,
                ThirdVessel: values.third_vissel,
                ThirdTransshipmentId: values.third_vissel_transshipment,
                FreightTermsId: values.freight_terms,
                IncotermsId: values.inco_terms,
                ContainerStockType: values.container_require_select,
                ContainerGrade: values.grade,
                ContainerApplyPlasticSheet: values.apply_layer_plastic_sheet,
                FirstPickupDate: values.first_pickup || null,
                ActualPickupDate: values.actual_pickup || null,
                DepotsId: values.depots?.DepotsId,
                InboundTransportGroupId: values.transport_InBound,
                InboundGateOutId: values.InBoundGateOut?.LocationId || null,
                InboundContainerGender: values.container_gender_Inbound,
                InboundVoyNo: values.voyIn,
                InboundQuantity: values.InboundQuantity,
                InboundETDGateOut: values.ETD_Gate_Out_Inbound,
                InboundETAGateIn: values.ETA_Gate_In_Inbound,
                InboundVoyNo_2: values.voyIn_2,
                InboundQuantity_2: values.InboundQuantity_2,
                InboundETDGateOut_2: values.ETD_Gate_Out_Inbound_2,
                InboundETAGateIn_2: values.ETA_Gate_In_Inbound_2,
                InboundVoyNo_3: values.voyIn_3,
                InboundQuantity_3: values.InboundQuantity_3,
                InboundETDGateOut_3: values.ETD_Gate_Out_Inbound_3,
                InboundETAGateIn_3: values.ETD_Gate_Out_Inbound_3,
                MtCntr: rowMTCACS.map((x) => ({
                  MtCntrId: null,
                  TruckRequest: x.Truck,
                  Vender: x.Vender,
                  NumberOfTrucks: x.NumberOfTrucks,
                })),
                StuffingPlan: rowStuffing.map((x) => ({
                  StuffingPlanId: null,
                  FactoryId: x.Factory?.FactoryId,
                  PickupDate: moment(x.PUD).format("yyyy-MM-DD"),
                  ReturnDate: moment(x.RD).format("yyyy-MM-DD"),
                  Quantity: Number(x.QTT) || 0,
                })),
                OutboundTransportGroupId: values.transport_OutBound,
                OutboundGateOutId: values.OutBoundGateOut?.LocationId || null,
                OutboundContainerGender: values.container_gender_OutBound,
                FirstLadenDate: values.first_Laden_Date || null,
                ActualLadenDate: values.actual_Laden_Date || null,
                OutboundVoyNo: values.voyOut,
                OutboundETDGateOut: values.ETD_Gate_Out_OutBound,
                OutboundETAGateIn: values.ETA_Gate_In_OutBound,
                OutboundQuantity: values.OutboundQuantity,
                OutboundVoyNo_2: values.voyOut_2,
                OutboundETDGateOut_2: values.ETD_Gate_Out_OutBound_2,
                OutboundETAGateIn_2: values.ETA_Gate_In_OutBound_2,
                OutboundQuantity_2: values.OutboundQuantity_2,
                OutboundVoyNo_3: values.voyOut_3,
                OutboundETDGateOut_3: values.ETD_Gate_Out_OutBound_3,
                OutboundETAGateIn_3: values.ETA_Gate_In_OutBound_3,
                OutboundQuantity_3: values.OutboundQuantity_3,
                Fumigation: values.fumigation,
                FumigationInspectionStaionId:
                  values.FumigationInspectionStaionId,
                FumigationRemark: values.fumigation_remark,
                PhytoCert: values.phyto_cert,
                PhytoCertInspectionStaionId: values.PhytoCertInspectionStaionId,
                PhytoCertRemark: values.phyto_cert_remark,
                FumigationPQNo: values.FumigationPQNo,
                TerminalName: values.TerminalName?.TerminalName || null,
              };
              const postData = async () => {
                const res = await api.post("api/saleorder/create", body);
                const data = await res.data;
                if (res.meta.status === true) {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่ม Sale Order สำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/CustomerSupport/SaleOrder");
                      }
                    });
                  });
                }
              };
              setTimeout(() => {
                postData();
                // console.log(body)
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  Forwarding
                </h6>
\                <Grid container>
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      options={forwarderData}
                      getOptionLabel={(option) => option?.CustomerName}
                      classes={{
                        root: !values.forwarding ? classes.customOutline : null,
                      }}
                      required
                      onChange={(x, y) => {
                        if (y !== null) {
                          setForwardingId(y?.CustomerId);
                          setFieldValue("forwarding", y);
                        }
                      }}
                      value={values.forwarding}
                      id="flat-demo"
                      renderInput={(params) => (
                        <TextField {...params} label="Forwarding" />
                      )}
                    />
                    {/* <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={forwarderData}
                      getOptionLabel={(option) => option?.CustomerName}
                      onChange={(x, y) => {
                        if (y !== null) {
                          setForwardingId(y?.CustomerId);
                          setFieldValue("forwarding", y);
                        }
                      }}
                      classes={{
                        root: !values.forwarding ? classes.customOutline : null,
                      }}
                      values={values.forwarding || null}
                      required
                      renderInput={(params) => (
                        <TextField
                          name="forwarding"
                          label="Forwarding"
                          variant="outlined"
                          placeholder="Forwarding"
                          // onChange={handleChange}
                          // onBlur={handleBlur}
                          // required
                          // InputLabelProps={{ shrink: true }}
                          // value={values.forwarding}
                          {...params}
                          fullWidth
                        />
                      )}
                    /> */}
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      CUSTOMER
                    </h6>
                    <Autocomplete
                      options={customerData}
                      getOptionLabel={(option) => option?.CustomerName}
                      classes={{
                        root: !values.forwarding ? classes.customOutline : null,
                      }}
                      required
                      onChange={(x, y) => {
                        if (y !== null) {
                          getQuotation(x, y);
                          setFieldValue("customer_name", y);
                        }
                      }}
                      value={values.customer_name}
                      id="flat-demo"
                      renderInput={(params) => (
                        <TextField {...params} label="CUSTOMER NAME" />
                      )}
                    />
                    {/* <div>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={customerData}
                        getOptionLabel={(option) => option?.CustomerName}
                        onChange={(x, y) => {
                          getQuotation(x, y);
                          setFieldValue("customer_name", y?.CustomerId);
                        }}
                        required
                        renderInput={(params) => (
                          <TextField
                            name="customer_name"
                            label="CUSTOMER NAME"
                            variant="outlined"
                            placeholder="Customer Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            InputLabelProps={{ shrink: true }}
                            value={values.customer_name}
                            required
                            classes={{
                              root: !values.customer_name
                                ? classes.customOutline
                                : null,
                            }}
                            {...params}
                            fullWidth
                          />
                        )}
                      />
                    </div> */}
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl
                        sx={{ width: "50%" }}
                        classes={{
                          root: !values.quotation_no
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Refer Quotation no.</InputLabel>
                        <Select
                          name="quotation_no"
                          value={values.quotation_no ? values.quotation_no : ""}
                          onChange={(e) => {
                            setFieldValue("quotation_no", e.target.value);
                            setQuotationID(e.target.value);
                            const _quotationId = e.target.value;
                            const quatation = quotationData.find(
                              (x) => x.QuotationId === _quotationId
                            );

                            const countryPol = locationData.find(
                              (x) => x.LocationId === quatation?.LocationFrom
                            );
                            const OutBoundGateOut = locationData.find(
                              (x) => x.LocationId === quatation?.LocationTo
                            );

                            setFieldValue("commodity", quatation?.CommodityId);
                            setFieldValue("InBoundGateOut", OutBoundGateOut);
                            setFieldValue(
                              "transport_InBound",
                              quatation?.GroupTo
                            );
                            setFieldValue("OutBoundGateOut", countryPol);
                            setFieldValue(
                              "transport_OutBound",
                              quatation?.GroupFrom
                            );
                            setFieldValue(
                              "detail_quotation",
                              quatation?.ServiceInfo
                            );
                            setFieldValue(
                              "TripType",
                              quatation?.TripType || "Round Trip"
                            );
                            setFieldValue(
                              "TripDirection",
                              quatation?.TripDirection || ""
                            );
                            setFieldValue(
                              "ServiceType",
                              quatation?.ServiceType || ""
                            );
                            // One-Way = leg ที่ทำงานเป็น laden — ตั้ง default gender ให้ (ยังแก้เองได้)
                            if (
                              quatation?.TripType === "One-Way" &&
                              quatation?.TripDirection === "Import"
                            ) {
                              setFieldValue("container_gender_Inbound", "Laden");
                            }
                            if (
                              quatation?.TripType === "One-Way" &&
                              quatation?.TripDirection === "Export"
                            ) {
                              setFieldValue("container_gender_OutBound", "Laden");
                            }
                          }}
                          onBlur={handleBlur}
                          label="Refer Quotation no."
                        >
                          <MenuItem value="" disabled>
                            <em>กรุณาค้นหา CustomerName </em>
                          </MenuItem>
                          {quotationData?.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.QuotationId}>
                                {option?.QuotationNo}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <TextField
                        name="shipper_ref_no"
                        label="SHIPPER REF NO."
                        variant="outlined"
                        placeholder="SHIPPER REF NO."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginLeft: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.shipper_ref_no}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="shipper_si_no"
                        label="SHIPPER SI NO."
                        variant="outlined"
                        placeholder="SHIPPER SI NO."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.shipper_si_no}
                      />

                      <TextField
                        name="shipper_invoice_no"
                        label="SHIPPER INVOICE. NO."
                        variant="outlined"
                        placeholder="SHIPPER INVOICE. NO."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.shipper_invoice_no}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        label="รายละเอียดตู้ Quotation"
                        value={values.detail_quotation}
                        name="detail_quotation"
                        InputLabelProps={{ shrink: true }}
                        disabled
                        multiline
                        rows={2}
                        fullWidth
                      />
                    </div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      VOLUME
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        marginTop: 10,
                      }}
                    >
                      <FormControl
                        sx={{ width: "50%" }}
                        classes={{
                          root: !values.volume_container
                            ? classes.customOutline
                            : null,
                        }}
                        required
                      >
                        <InputLabel>Container</InputLabel>
                        <Select
                          name="volume_container"
                          label="Container "
                          value={values.volume_container || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ borderColor: "red" }}
                          classes={{
                            root: !values.quotation_no
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก Container</em>
                          </MenuItem>
                          {containerData?.map((option, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={option?.ContainerTypeId}
                              >
                                {option?.ContainerTypeName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <TextField
                        name="volume_quantity"
                        label="Quantity"
                        variant="outlined"
                        placeholder="Quantity"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5, marginLeft: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.volume_quantity}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl sx={{ width: "50%", mr: "5px" }}>
                        <InputLabel>COMMODITY</InputLabel>
                        <Select
                          name="commodity"
                          label="COMMODITY"
                          disabled
                          value={values.commodity || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            setFieldValue("commodity", e.target.value);
                          }}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก COMMODITY </em>
                          </MenuItem>

                          {commodityData?.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.CommodityId}>
                                {option?.CommodityName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>

                      <FormControl sx={{ width: "25%", mr: "5px" }}>
                        <InputLabel>PACKAGING</InputLabel>
                        <Select
                          name="packaging"
                          label="PACKAGING"
                          value={values.packaging || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก PACKAGING </em>
                          </MenuItem>

                          {packageData.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.PackageId}>
                                {option?.PackageName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <h4
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Booking Information
                    </h4>
                    <div style={{ marginTop: 10 }}>
                      <TextField
                        name="booking_no"
                        label="BOOKING NO."
                        variant="outlined"
                        placeholder="BOOKING NO."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        InputLabelProps={{ shrink: true }}
                        value={values.booking_no}
                        fullWidth
                      />
                    </div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Shipping Line
                    </h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <Autocomplete
                        name="liners"
                        options={linersData}
                        getOptionLabel={(option) => option?.LinersName}
                        onChange={(x, y) => {
                          setFieldValue("liners", y);
                        }}
                        id="flat-demo"
                        value={values.liners}
                        sx={{ width: "50%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="LINERS" />
                        )}
                      />

                      <Autocomplete
                        name="freight_forwarder"
                        options={freightForwarderData}
                        getOptionLabel={(option) =>
                          option?.FreightForwarderName
                        }
                        onChange={(x, y) => {
                          setFieldValue("freight_forwarder", y);
                        }}
                        id="flat-demo"
                        value={values.freight_forwarder}
                        sx={{ width: "50%", ml: "5px" }}
                        renderInput={(params) => (
                          <TextField {...params} label="FREIGHT FORWARDER" />
                        )}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ width: "100%", flexBasis: "50%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          ETD POL
                        </h6>
                        <div style={{ display: "flex" }}>
                          <DesktopDatePicker
                            label="ETD POL"
                            inputFormat="dd/MM/yyyy"
                            name="etd_pol"
                            disablePast
                            value={values?.etd_pol}
                            onChange={(e) => {
                              const nformat = moment(e).format("yyyy-MM-DD");
                              setFieldValue("etd_pol", nformat);
                              if (values.com) {
                                const pickup_Em = SUM_FREETIME(
                                  values.CountingType + "_PE",
                                  nformat,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_Laden_Date,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                const laden_Date = SUM_FREETIME(
                                  values.CountingType + "_RL",
                                  nformat,
                                  values.closing_date,
                                  pickup_Em,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );

                                if (pickup_Em) {
                                  setFieldValue("first_pickup", pickup_Em);
                                }
                                if (laden_Date) {
                                  setFieldValue("first_Laden_Date", laden_Date);
                                }
                              } else {
                                const pickup_Date = SUM_FREETIME(
                                  values.CountingType + "_DET",
                                  nformat,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_Laden_Date,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                const laden_Date = SUM_FREETIME(
                                  values.CountingType + "_DEM",
                                  nformat,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                if (pickup_Date) {
                                  setFieldValue("first_pickup", pickup_Date);
                                }
                                if (laden_Date) {
                                  setFieldValue("first_Laden_Date", laden_Date);
                                }
                              }

                              setEtd(nformat);

                              // setFieldValue("etd_pol", nformat);

                              // if (values.dem != "" && values.det != "") {
                              //   let cal_days =
                              //     -(parseInt(values.det) + parseInt(values.dem)) +
                              //     2;
                              //   let caldet = +parseInt(values.det);
                              //   let cal_dayss = +parseInt(values.dem);
                              //   let date_now = +new Date(nformat);
                              //   if (values.det != "" && values.dem != "") {
                              //     setFieldValue(
                              //       "first_pickup",
                              //       moment(
                              //         new Date(
                              //           date_now + cal_days * 24 * 60 * 60 * 1000
                              //         )
                              //       ).format("YYYY-MM-DD")
                              //     );

                              //   }
                              // }

                              // if (
                              //   values.com != "" &&
                              //   values.det == "" &&
                              //   values.dem == "" &&
                              //   values.choice_com_calculate == "1"
                              // ) {
                              //   let date_now = +new Date(nformat);
                              //   let com_value = -values.com + 1;
                              //   setFieldValue(
                              //     "first_pickup",
                              //     moment(
                              //       new Date(
                              //         date_now + com_value * 24 * 60 * 60 * 1000
                              //       )
                              //     ).format("YYYY-MM-DD")
                              //   );
                              // }
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{ width: "50%" }}
                                {...params}
                                classes={{
                                  root: !values?.etd_pol
                                    ? classes.customOutline
                                    : null,
                                }}
                                required
                              />
                            )}
                          />
                          <TextField
                            name="etd_time"
                            label="ETD TIME"
                            variant="outlined"
                            placeholder="ETD TIME"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginLeft: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.etd_time}
                          />
                        </div>
                      </div>
                      <div style={{ width: "100%", flexBasis: "50%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Closing
                        </h6>
                        <div style={{ display: "flex" }}>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="closing_date"
                            label="CLOSING DATE"
                            maxDate={new Date(dateetd)}
                            value={values.closing_date}
                            onChange={(e) => {
                              const nformat = moment(e).format("YYYY-MM-DD");

                              const mformat = moment(e).format("YYYY-MM-DD");
                              setFieldValue("closing_date", nformat);

                              if (values.com) {
                                const pickup_Date = SUM_FREETIME(
                                  values.CountingType + "_PE",
                                  values.etd_pol,
                                  nformat,
                                  values.first_pickup,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                if (pickup_Date) {
                                  setFieldValue("first_pickup", pickup_Date);
                                }
                              } else {
                                const pickup_Date = SUM_FREETIME(
                                  values.CountingType + "_DET",
                                  values.etd_pol,
                                  nformat,
                                  values.first_pickup,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                if (pickup_Date) {
                                  setFieldValue("first_pickup", pickup_Date);
                                }
                              }

                              // setClosingdate(mformat);
                              // if (
                              //   values.com != "" &&
                              //   values.det == "" &&
                              //   values.dem == "" &&
                              //   values.choice_com_calculate == "2"
                              // ) {
                              //   let date_now = +new Date(nformat);

                              //   setFieldValue(
                              //     "first_pickup",
                              //     moment(
                              //       new Date(
                              //         date_now + values.com * 24 * 60 * 60 * 1000
                              //       )
                              //     ).format("YYYY-MM-DD")
                              //   );
                              // }
                            }}
                            renderInput={(params) => (
                              <TextField
                                style={{
                                  width: "50%",
                                  marginRight: 5,
                                  marginLeft: 5,
                                }}
                                {...params}
                                classes={{
                                  root:
                                    !values.closing_date ||
                                    values.closing_date >= values.eta_pod
                                      ? classes.customOutline
                                      : null,
                                }}
                                required
                              />
                            )}
                          />
                          <TextField
                            name="closing_time"
                            label="CLOSING TIME"
                            variant="outlined"
                            placeholder="CLOSING TIME"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginRight: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.closing_time}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Port of Loading
                        </h6>
                        <div style={{ display: "flex" }}>
                          <Autocomplete
                            name="Country"
                            options={countryData}
                            getOptionLabel={(option) => option?.CountryName}
                            onChange={(x, y) => {
                              setFieldValue("pol_conuntry", y);
                              setFieldValue("pol_terminal", null);
                            }}
                            id="flat-demo"
                            value={values.pol_conuntry}
                            sx={{ width: "50%", mr: "5px" }}
                            renderInput={(params) => (
                              <TextField {...params} label="Country" />
                            )}
                          />
                          <Autocomplete
                            name="pol_terminal"
                            options={terminalData?.filter(
                              (x) =>
                                x.CountryId === values.pol_conuntry?.CountryId
                            )}
                            getOptionLabel={(option) => option?.LocationName}
                            onChange={(x, y) => {
                              setFieldValue("pol_terminal", y);
                            }}
                            id="flat-demo"
                            value={values.pol_terminal}
                            sx={{ width: "50%", mr: "5px" }}
                            renderInput={(params) => (
                              <TextField {...params} label="Location" />
                            )}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider sx={{ margin: "20px 0" }} />

                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%" }}>
                        <h6 className="textcolordarkblue">Port of Discharge</h6>
                        <div style={{ display: "flex" }}>
                          <Autocomplete
                            name="Country"
                            options={countryData}
                            getOptionLabel={(option) => option?.CountryName}
                            onChange={(x, y) => {
                              setFieldValue("pod_conuntry", y);
                              setFieldValue("pod_terminal", null);
                            }}
                            id="flat-demo"
                            value={values.pod_conuntry}
                            sx={{ width: "50%", mr: "5px" }}
                            renderInput={(params) => (
                              <TextField {...params} label="Country" />
                            )}
                          />
                          <Autocomplete
                            name="pod_terminal"
                            options={terminalData?.filter(
                              (x) =>
                                x.CountryId === values.pod_conuntry?.CountryId
                            )}
                            getOptionLabel={(option) => option?.LocationName}
                            onChange={(x, y) => {
                              setFieldValue("pod_terminal", y);
                            }}
                            id="flat-demo"
                            value={values.pod_terminal}
                            sx={{ width: "50%", mr: "5px" }}
                            renderInput={(params) => (
                              <TextField {...params} label="Location" />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ width: "100%", flexBasis: "50%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          ETA POD
                        </h6>
                        <div style={{ display: "flex" }}>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="eta_pod"
                            label="ETA POD"
                            value={values.eta_pod}
                            disablePast
                            sx={{
                              color: "red",
                            }}
                            onChange={(e) => {
                              const nformat = moment(e).format("YYYY-MM-DD");
                              setFieldValue("eta_pod", nformat);
                            }}
                            renderInput={(params) => (
                              <>
                                <TextField
                                  error
                                  sx={{
                                    width: "100%",
                                  }}
                                  {...params}
                                />
                              </>
                            )}
                          />

                          <TextField
                            name="eta_time"
                            label="ETA TIME"
                            variant="outlined"
                            placeholder="ETA TIME"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginLeft: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.eta_time}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        FREE TIME
                      </h6>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="det"
                          label="Detention"
                          type="number"
                          variant="outlined"
                          placeholder="Detention"
                          classes={{
                            root: !values.det ? classes.customOutline : null,
                          }}
                          onChange={(e) => {
                            setFieldValue("det", e.target.value);
                            // if (values.CountingType === "ETD POL") {
                            //   setFieldValue("first_pickup", SUM_ETD_POL_Detention(values.etd_pol, e.target.value))
                            // }
                            const pickup_Date = SUM_FREETIME(
                              values.CountingType + "_DET",
                              values.etd_pol,
                              values.closing_date,
                              values.first_pickup,
                              values.actual_Laden_Date,
                              e.target.value,
                              values.dem,
                              values.com
                            );
                            if (pickup_Date) {
                              setFieldValue("first_pickup", pickup_Date);
                            }

                            // let cal_days =
                            //   -(parseInt(e.target.value) + parseInt(values.dem)) +
                            //   2;
                            // let cal_dayss = +parseInt(values.dem);
                            // let cal_det = +parseInt(e.target.value);
                            // let date_now = +new Date(dateetd);
                            // if (
                            //   e.target.value != "" &&
                            //   values.dem != "" &&
                            //   values.etd_pol != ""
                            // ) {
                            //   setFieldValue(
                            //     "first_pickup",
                            //     moment(
                            //       new Date(
                            //         date_now + cal_days * 24 * 60 * 60 * 1000
                            //       )
                            //     ).format("YYYY-MM-DD")
                            //   );

                            //   setFieldValue(
                            //     "first_Laden_Date",
                            //     moment(
                            //       new Date(
                            //         date_now +
                            //         cal_days * 24 * 60 * 60 * 1000 +
                            //         (cal_det - 1) * 24 * 60 * 60 * 1000
                            //       )
                            //     ).format("YYYY-MM-DD")
                            //   );

                            // }
                            // if (e.target.value == "") {
                            //   setFieldValue("first_pickup", "");
                            // }
                            // e.target.value.length >= 1 || values.dem != ""
                            //   ? setComDisable(true)
                            //   : setComDisable(false);
                          }}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          disabled={values.com}
                          value={values.det}
                        />
                        <TextField
                          name="dem"
                          label="Demurrage"
                          type="number"
                          variant="outlined"
                          placeholder="Demurrage"
                          classes={{
                            root: !values.dem ? classes.customOutline : null,
                          }}
                          onChange={(e) => {
                            setFieldValue("dem", e.target.value);
                            // if (values.CountingType === "ETD POL") {
                            //   setFieldValue("first_Laden_Date", SUM_ETD_POL_Demurrage(values.etd_pol, e.target.value))
                            // }
                            const laden_Date = SUM_FREETIME(
                              values.CountingType + "_DEM",
                              values.etd_pol,
                              values.closing_date,
                              values.first_pickup,
                              values.actual_pickup,
                              values.det,
                              e.target.value,
                              values.com
                            );
                            if (laden_Date) {
                              setFieldValue("first_Laden_Date", laden_Date);
                            }

                            // let cal_days =
                            //   -(parseInt(values.det) + parseInt(e.target.value)) +
                            //   2;
                            // let cal_dayss = +parseInt(values.dem);
                            // let cal_det = +parseInt(values.det);
                            // let date_now = +new Date(dateetd);
                            // if (
                            //   values.det != "" &&
                            //   e.target.value != "" &&
                            //   values.etd_pol != ""
                            // ) {
                            //   setFieldValue(
                            //     "first_pickup",
                            //     moment(
                            //       new Date(
                            //         date_now + cal_days * 24 * 60 * 60 * 1000
                            //       )
                            //     ).format("YYYY-MM-DD")
                            //   );

                            //   setFieldValue(
                            //     "first_Laden_Date",
                            //     moment(
                            //       new Date(
                            //         date_now +
                            //         cal_days * 24 * 60 * 60 * 1000 +
                            //         (cal_det - 1) * 24 * 60 * 60 * 1000
                            //       )
                            //     ).format("YYYY-MM-DD")
                            //   );

                            // }
                            // if (e.target.value == "") {
                            //   setFieldValue("first_pickup", "");
                            // }

                            // e.target.value.length >= 1 || values.det != ""
                            //   ? setComDisable(true)
                            //   : setComDisable(false);
                          }}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          disabled={values.com}
                          value={values.dem}
                        />

                        <TextField
                          name="com"
                          label="Combined"
                          type="number"
                          variant="outlined"
                          placeholder="COM"
                          classes={{
                            root: !values.com ? classes.customOutline : null,
                          }}
                          onChange={(e) => {
                            setFieldValue("com", e.target.value);
                            // setCom_caluateSelect(true);
                            if (e.target.value == "") {
                              setCom_caluateSelect(false);
                              setFieldValue("first_pickup", "");
                              setFieldValue("choice_com_calculate", "");
                            } else {
                              const pickup_Em = SUM_FREETIME(
                                values.CountingType + "_PE",
                                values.etd_pol,
                                values.closing_date,
                                values.first_pickup,
                                values.actual_Laden_Date,
                                values.det,
                                values.dem,
                                e.target.value
                              );
                              const laden_Date = SUM_FREETIME(
                                values.CountingType + "_RL",
                                values.etd_pol,
                                values.closing_date,
                                pickup_Em,
                                values.actual_pickup,
                                values.det,
                                values.dem,
                                e.target.value
                              );

                              if (pickup_Em) {
                                setFieldValue("first_pickup", pickup_Em);
                              }
                              if (laden_Date) {
                                setFieldValue("first_Laden_Date", laden_Date);
                              }
                            }
                            // e.target.value.length >= 1
                            //   ? setDetDemDisable(true)
                            //   : setDetDemDisable(false);
                          }}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.com}
                          disabled={values.dem || values.det}
                        />
                        {/* {com_caluateSelect ? (
                          <>
                            <TextField
                              name="c_det"
                              label="DET"
                              type="number"
                              error={
                                parseInt(values.c_det) +
                                  parseInt(values.c_dem) <=
                                  values.com
                                  ? false
                                  : true
                              }
                              variant="outlined"
                              placeholder="DET"
                              onChange={(e) => {
                                setFieldValue("c_det", e.target.value);

                                let cal_days =
                                  -(
                                    parseInt(e.target.value) +
                                    parseInt(values.c_dem)
                                  ) + 2;
                                let cal_dayss = +parseInt(values.c_dem);
                                let cal_det = +parseInt(e.target.value);

                                let date_now = +new Date(values.etd_pol);
                                if (
                                  e.target.value != "" &&
                                  values.c_dem != "" &&
                                  values.etd_pol != ""
                                ) {
                                  setFieldValue(
                                    "first_pickup",
                                    moment(
                                      new Date(
                                        date_now +
                                        cal_days * 24 * 60 * 60 * 1000
                                      )
                                    ).format("YYYY-MM-DD")
                                  );

                                  setFieldValue(
                                    "first_Laden_Date",
                                    moment(
                                      new Date(
                                        date_now +
                                        cal_days * 24 * 60 * 60 * 1000 +
                                        (cal_det - 1) *
                                        24 *
                                        60 *
                                        60 *
                                        1000
                                      )
                                    ).format("YYYY-MM-DD")
                                  );
                                }
                                if (e.target.value == "") {
                                  setFieldValue("first_pickup", "");
                                }
                              }}
                              onBlur={handleBlur}
                              style={{ width: "50%", marginRight: 5 }}
                              InputLabelProps={{ shrink: true }}
                              value={values.c_det}
                            />
                            <TextField
                              name="c_dem"
                              label="DEM"
                              error={
                                parseInt(values.c_det) +
                                  parseInt(values.c_dem) <=
                                  values.com
                                  ? false
                                  : true
                              }
                              type="number"
                              variant="outlined"
                              placeholder="DEM"
                              onChange={(e) => {
                                setFieldValue("c_dem", e.target.value);
                                let cal_days =
                                  -(
                                    parseInt(values.c_det) +
                                    parseInt(e.target.value)
                                  ) + 2;
                                let cal_dayss = +parseInt(values.c_dem);
                                let cal_det = +parseInt(values.c_det);
                                let date_now = +new Date(values.etd_pol);
                                if (
                                  values.c_det != "" &&
                                  e.target.value != "" &&
                                  values.etd_pol != "" &&
                                  parseInt(values.c_det) +
                                  parseInt(e.target.value) <=
                                  values.com
                                ) {
                                  setFieldValue(
                                    "first_pickup",
                                    moment(
                                      new Date(
                                        date_now +
                                        cal_days * 24 * 60 * 60 * 1000
                                      )
                                    ).format("YYYY-MM-DD")
                                  );
                                  setFieldValue(
                                    "first_Laden_Date",
                                    moment(
                                      new Date(
                                        date_now +
                                        cal_days * 24 * 60 * 60 * 1000 +
                                        (cal_det - 1) *
                                        24 *
                                        60 *
                                        60 *
                                        1000
                                      )
                                    ).format("YYYY-MM-DD")
                                  );
                                }
                                if (e.target.value == "") {
                                  setFieldValue("first_pickup", "");
                                }
                              }}
                              onBlur={handleBlur}
                              style={{ width: "50%", marginRight: 5 }}
                              InputLabelProps={{ shrink: true }}
                              value={values.c_dem}
                            />
                          </>
                        ) : null} */}
                        <FormControl sx={{ width: "50%" }}>
                          <InputLabel>Counting</InputLabel>
                          <Select
                            name="CountingType"
                            label="Counting"
                            value={values.CountingType || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setFieldValue("CountingType", e.target.value);
                              console.log(e.target.value);
                              if (values.com) {
                                const pickup_Em = SUM_FREETIME(
                                  e.target.value + "_PE",
                                  values.etd_pol,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_Laden_Date,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                const laden_Date = SUM_FREETIME(
                                  e.target.value + "_RL",
                                  values.etd_pol,
                                  values.closing_date,
                                  pickup_Em,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );

                                if (pickup_Em) {
                                  setFieldValue("first_pickup", pickup_Em);
                                }
                                if (laden_Date) {
                                  setFieldValue("first_Laden_Date", laden_Date);
                                }
                              } else {
                                const pickup_Date = SUM_FREETIME(
                                  e.target.value + "_DET",
                                  values.etd_pol,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_Laden_Date,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                const laden_Date = SUM_FREETIME(
                                  e.target.value + "_DEM",
                                  values.etd_pol,
                                  values.closing_date,
                                  values.first_pickup,
                                  values.actual_pickup,
                                  values.det,
                                  values.dem,
                                  values.com
                                );
                                if (pickup_Date) {
                                  setFieldValue("first_pickup", pickup_Date);
                                }
                                if (laden_Date) {
                                  setFieldValue("first_Laden_Date", laden_Date);
                                }
                              }
                            }}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="Return Laden">
                              Return Laden
                            </MenuItem>
                            <MenuItem value="Closing">Closing</MenuItem>
                            <MenuItem value="ETD POL">ETD POL</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ width: "100%", flexBasis: "50%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Cut off VGM
                        </h6>
                        <div style={{ display: "flex" }}>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="cut_off_VGM"
                            label="Data"
                            value={values.cut_off_VGM}
                            onChange={(e) => {
                              const nformat = moment(e).format("YYYY-MM-DD");

                              setFieldValue("cut_off_VGM", nformat);
                            }}
                            renderInput={(params) => (
                              <>
                                <TextField
                                  error
                                  sx={{
                                    width: "100%",
                                  }}
                                  {...params}
                                />
                              </>
                            )}
                          />

                          <TextField
                            name="cut_off_VGM_time"
                            label="TIME"
                            variant="outlined"
                            placeholder="TIME"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginLeft: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cut_off_VGM_time}
                          />
                        </div>
                      </div>
                      <div style={{ width: "100%", flexBasis: "50%" }}>
                        <h6
                          style={{ marginTop: "10px" }}
                          className="textcolordarkblue"
                        >
                          Cut off SI
                        </h6>
                        <div style={{ display: "flex", marginLeft: 5 }}>
                          <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            name="cut_off_SI"
                            label="Date"
                            value={values.cut_off_SI}
                            onChange={(e) => {
                              const nformat = moment(e).format("YYYY-MM-DD");

                              setFieldValue("cut_off_SI", nformat);
                            }}
                            renderInput={(params) => (
                              <>
                                <TextField
                                  error
                                  sx={{
                                    width: "100%",
                                  }}
                                  {...params}
                                />
                              </>
                            )}
                          />

                          <TextField
                            name="cut_off_SI_time"
                            label="TIME"
                            variant="outlined"
                            placeholder="TIME"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{ width: "50%", marginLeft: 5 }}
                            InputLabelProps={{ shrink: true }}
                            value={values.cut_off_SI_time}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider sx={{ margin: "20px 0" }} />

                    <h6 className="textcolordarkblue">Intended Vessel</h6>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="first_vissel"
                        label="Feeder Vessel"
                        variant="outlined"
                        placeholder="Feeder Vessel"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.first_vissel}
                      />
                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel>TRANSHIPMENT</InputLabel>
                        <Select
                          name="first_vissel_transshipment"
                          label="TRANSHIPMENT"
                          value={values.first_vissel_transshipment || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          endAdornment={
                            values.first_vissel_transshipment && (
                              <InputAdornment
                                position="end"
                                sx={{ marginRight: "30px" }}
                              >
                                <IconButton
                                  onClick={() =>
                                    setFieldValue(
                                      "first_vissel_transshipment",
                                      ""
                                    )
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </InputAdornment>
                            )
                          }
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก TRANSSHIPMENT </em>
                          </MenuItem>
                          {transshipmentData.map((option, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={option?.TransshipmentId}
                              >
                                {option?.TransshipmentName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="second_vissel"
                        label="Mother Vessel"
                        variant="outlined"
                        placeholder="Mother Vessel"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.second_vissel}
                      />
                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel>TRANSHIPMENT</InputLabel>
                        <Select
                          name="second_vissel_transshipment"
                          label="TRANSHIPMENT"
                          value={values.second_vissel_transshipment || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          endAdornment={
                            values.second_vissel_transshipment && (
                              <InputAdornment
                                position="end"
                                sx={{ marginRight: "30px" }}
                              >
                                <IconButton
                                  onClick={() =>
                                    setFieldValue(
                                      "second_vissel_transshipment",
                                      ""
                                    )
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </InputAdornment>
                            )
                          }
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก TRANSSHIPMENT </em>
                          </MenuItem>
                          {transshipmentData.map((option, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={option?.TransshipmentId}
                              >
                                {option?.TransshipmentName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="third_vissel"
                        label="Vessel 3RD"
                        variant="outlined"
                        placeholder="Vessel 3RD"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.third_vissel}
                      />
                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel>TRANSHIPMENT</InputLabel>
                        <Select
                          name="third_vissel_transshipment"
                          label="TRANSHIPMENT"
                          value={values.third_vissel_transshipment || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          endAdornment={
                            values.third_vissel_transshipment && (
                              <InputAdornment
                                position="end"
                                sx={{ marginRight: "30px" }}
                              >
                                <IconButton
                                  onClick={() =>
                                    setFieldValue(
                                      "third_vissel_transshipment",
                                      ""
                                    )
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </InputAdornment>
                            )
                          }
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก TRANSSHIPMENT </em>
                          </MenuItem>
                          {transshipmentData.map((option, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={option?.TransshipmentId}
                              >
                                {option?.TransshipmentName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl style={{ width: "50%", marginRight: 5 }}>
                        <InputLabel>INCO TERMS</InputLabel>
                        <Select
                          name="inco_terms"
                          label="INCO TERMS"
                          value={values.inco_terms || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก INCO TERMS </em>
                          </MenuItem>
                          {incotermData.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option?.IncotermsId}>
                                {option?.IncotermName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>

                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel>FREIGHT TERMS</InputLabel>
                        <Select
                          name="freight_terms"
                          label="FREIGHT TERMS"
                          value={values.freight_terms || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value="" disabled>
                            <em>เลือก FREIGHT TERMS </em>
                          </MenuItem>
                          {termsData.map((option, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={option?.FreightTermsId}
                              >
                                {option?.FreightTermsName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      Container Status
                    </h6>
                    <div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <FormControl
                          sx={{ width: "50%", mr: "5px" }}
                          classes={{
                            root: !values.container_require_select
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <InputLabel>Container Stock</InputLabel>
                          <Select
                            name="container_require_select"
                            label="Container Stock"
                            value={values.container_require_select || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="Stock">Stock</MenuItem>
                            <MenuItem value="Out Stock">Out Stock</MenuItem>
                          </Select>
                        </FormControl>
                        <TextField
                          name="grade"
                          label="Grade"
                          variant="outlined"
                          placeholder="Grade"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={values.grade}
                        />

                        <FormControl sx={{ width: "50%", ml: "5px" }}>
                          <InputLabel>PLASTIC SHEET</InputLabel>
                          <Select
                            name="apply_layer_plastic_sheet"
                            label=" PLASTIC SHEET"
                            value={values.apply_layer_plastic_sheet || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value={1}>Yes</MenuItem>
                            <MenuItem value={0}>No</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="first_pickup"
                          label="1ST PICK UP"
                          variant="outlined"
                          placeholder="1ST PICK UP"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ readOnly: true }}
                          value={
                            values.first_pickup
                              ? moment(values.first_pickup).format("DD/MM/yyyy")
                              : null
                          }
                        />

                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          name="actual_pickup"
                          label="Actual PICK UP"
                          value={values.actual_pickup}
                          onChange={(e) => {
                            const nformat = moment(e).format("YYYY-MM-DD");
                            setFieldValue("actual_pickup", nformat);
                            // setFieldValue("first_pickup", SUM_FREETIME(e.target.value + '_PE', values.etd_pol, values.closing_date, values.first_pickup, values.actual_pickup, values.det, values.dem, e.target.value))
                            if (values.com) {
                              const laden_Date = SUM_FREETIME(
                                values.CountingType + "_RL",
                                values.etd_pol,
                                values.closing_date,
                                values.first_pickup,
                                nformat,
                                values.det,
                                values.dem,
                                values.com
                              );
                              if (laden_Date) {
                                setFieldValue("first_Laden_Date", laden_Date);
                              }
                            } else {
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "50%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        {values.actual_pickup && values.first_pickup ? (
                          <TextField
                            label="diff"
                            sx={{
                              marginRight: "5px",
                              "& .MuiInputBase-input": {
                                color:
                                  Math.round(
                                    // Math.abs(
                                    (new Date(values.actual_pickup) -
                                      new Date(values.first_pickup)) /
                                      // )
                                      1000 /
                                      60 /
                                      60 /
                                      24
                                  ) >= 0
                                    ? "#000"
                                    : "red",
                              },
                            }}
                            value={Math.round(
                              (new Date(values.actual_pickup) -
                                new Date(values.first_pickup)) /
                                1000 /
                                60 /
                                60 /
                                24
                            )}
                          />
                        ) : (
                          ""
                        )}

                        <Autocomplete
                          name="depots"
                          options={depotsData}
                          getOptionLabel={(option) => option?.DepotsName}
                          onChange={(x, y) => {
                            setFieldValue("depots", y);
                          }}
                          id="flat-demo"
                          value={values.depots}
                          sx={{ width: "50%", ml: "5px" }}
                          renderInput={(params) => (
                            <TextField {...params} label="DEPOTS" />
                          )}
                        />
                      </div>
                      {/* ซ่อน Inbound block เมื่อเป็นงาน One-Way / Export (เริ่มที่โรงงาน) */}
                      {!(values.TripType === "One-Way" && values.TripDirection === "Export") && (
                      <>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Transportation Inbound
                      </h6>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <FormControl
                          sx={{ width: "30%", mr: "5px" }}
                          classes={{
                            root: !values.transport_InBound
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <InputLabel>Transport</InputLabel>
                          <Select
                            name="transport_InBound"
                            label="Transport"
                            value={values.transport_InBound || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setFieldValue(
                                "transport_InBound",
                                e.target.value
                              );
                              setFieldValue("voyIn", "");
                              setFieldValue("ETA_Gate_In_Inbound", null);
                              setFieldValue("ETD_Gate_Out_Inbound", null);
                            }}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="" disabled>
                              <em>เลือก ประเภทการขนส่ง </em>
                            </MenuItem>
                            {groupData.map((option, index) => {
                              return (
                                <MenuItem key={index} value={option?.GroupId}>
                                  {option?.GroupName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <Autocomplete
                          options={locationData}
                          getOptionLabel={(option) => option?.LocationName}
                          classes={{
                            root: !values.InBoundGateOut
                              ? classes.customOutline
                              : null,
                          }}
                          required
                          onChange={(x, y) => {
                            setFieldValue("InBoundGateOut", y);
                          }}
                          id="flat-demo"
                          value={
                            values.InBoundGateOut ? values.InBoundGateOut : null
                          }
                          sx={{ width: "40%", mr: "5px" }}
                          renderInput={(params) => (
                            <TextField {...params} label="Gate Out" />
                          )}
                        />
                        <FormControl
                          sx={{ width: "30%", mr: "5px" }}
                          classes={{
                            root: !values.container_gender_Inbound
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <InputLabel>Container Gender</InputLabel>
                          <Select
                            name="container_gender_Inbound"
                            label="Empty / Laden"
                            value={values.container_gender_Inbound || ""}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="Empty">Empty</MenuItem>
                            <MenuItem value="Laden">Laden</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          label="Voy IN"
                          name="voyIn"
                          value={values.voyIn}
                          InputLabelProps={{ shrink: true }}
                          onBlur={handleBlur}
                          sx={{
                            width: "40%",
                            marginRight: "5px",
                            "& .MuiInputBase-input": {},
                          }}
                        />
                        {values.first_pickup &&
                          values.transport_InBound &&
                          values.InBoundGateOut && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setOpenVoyIn(true);
                                setSelectedDialog(1);
                                const body = {
                                  FirstPickupDate: values.first_pickup,
                                  InboundTransportGroupId:
                                    values.transport_InBound,
                                  InboundGateOutId:
                                    values.InBoundGateOut.LocationId,
                                  OutboundGateOutId:
                                    values.OutBoundGateOut.LocationId,
                                  ClosingDate: values.closing_date,
                                  ClosingTime: values.closing_time,
                                  ContainerTypeId: values.volume_container,
                                  Quantity: values.volume_quantity,
                                  CommodityId: values.commodity,
                                };
                                const getVoyIn = async () => {
                                  const res = await api.post(
                                    `api/saleorder/voy/inbound`,
                                    body
                                  );
                                  const data = await res.data;
                                  setVoyIn(data);
                                };
                                getVoyIn();
                              }}
                            >
                              search
                            </Button>
                          )}

                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          name="ETD_Gate_Out_Inbound"
                          label="ETD Gate Out"
                          value={values.ETD_Gate_Out_Inbound}
                          onChange={(e) => {
                            const nformat = moment(e).format("yyyy-MM-DD");
                            setFieldValue("ETD_Gate_Out_Inbound", nformat);
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "30%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          name="ETA_Gate_In_Inbound"
                          label="ETA Gate IN"
                          value={values.ETA_Gate_In_Inbound}
                          onChange={(e) => {
                            const nformat = moment(e).format("yyyy-MM-DD");
                            setFieldValue("ETA_Gate_In_Inbound", nformat);
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "30%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        {values.transport_InBound === "G002" && (
                          <TextField
                            name="InboundQuantity"
                            label="InboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.InboundQuantity || ""}
                          />
                        )}
                        {values.voyIn && (
                          <Button
                            color="error"
                            variant="contained"
                            onClick={() => {
                              setFieldValue("voyIn", "");
                              setFieldValue("ETA_Gate_In_Inbound", null);
                              setFieldValue("ETD_Gate_Out_Inbound", null);
                              setFieldValue("InboundQuantity", "");
                            }}
                          >
                            clear
                          </Button>
                        )}
                      </div>
                      {values.transport_InBound === "G002" && (
                        <>
                          <div style={{ display: "flex", marginTop: 10 }}>
                            <TextField
                              label="Voy IN"
                              name="voyIn_2"
                              value={values.voyIn_2}
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              sx={{
                                width: "40%",
                                marginRight: "5px",
                                "& .MuiInputBase-input": {},
                              }}
                            />
                            {values.first_pickup &&
                              values.transport_InBound &&
                              values.InBoundGateOut && (
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    setOpenVoyIn(true);
                                    setSelectedDialog(2);
                                    const body = {
                                      FirstPickupDate: values.first_pickup,
                                      InboundTransportGroupId:
                                        values.transport_InBound,
                                      InboundGateOutId:
                                        values.InBoundGateOut.LocationId,
                                      OutboundGateOutId:
                                        values.OutBoundGateOut.LocationId,
                                      ClosingDate: values.closing_date,
                                      ClosingTime: values.closing_time,
                                      ContainerTypeId: values.volume_container,
                                      Quantity: values.volume_quantity,
                                      CommodityId: values.commodity,
                                    };
                                    const getVoyIn = async () => {
                                      const res = await api.post(
                                        `api/saleorder/voy/inbound`,
                                        body
                                      );
                                      const data = await res.data;
                                      setVoyIn(data);
                                    };
                                    getVoyIn();
                                  }}
                                >
                                  search
                                </Button>
                              )}

                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              name="ETD_Gate_Out_Inbound_2"
                              label="ETD Gate Out"
                              value={values.ETD_Gate_Out_Inbound_2}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETD_Gate_Out_Inbound_2",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              name="ETA_Gate_In_Inbound_2"
                              label="ETA Gate IN"
                              value={values.ETA_Gate_In_Inbound_2}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue("ETA_Gate_In_Inbound_2", nformat);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <TextField
                              name="InboundQuantity_2"
                              label="InboundQuantity"
                              variant="outlined"
                              placeholder="Quantity"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                width: "20%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={values.InboundQuantity_2 || ""}
                            />
                            {values.voyIn_2 && (
                              <Button
                                color="error"
                                variant="contained"
                                onClick={() => {
                                  setFieldValue("voyIn_2", "");
                                  setFieldValue("ETA_Gate_In_Inbound_2", null);
                                  setFieldValue("ETD_Gate_Out_Inbound_2", null);
                                  setFieldValue("InboundQuantity_2", "");
                                }}
                              >
                                clear
                              </Button>
                            )}
                          </div>
                          <div style={{ display: "flex", marginTop: 10 }}>
                            <TextField
                              label="Voy IN"
                              name="voyIn"
                              value={values.voyIn_3}
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              sx={{
                                width: "40%",
                                marginRight: "5px",
                                "& .MuiInputBase-input": {},
                              }}
                            />
                            {values.first_pickup &&
                              values.transport_InBound &&
                              values.InBoundGateOut && (
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    setOpenVoyIn(true);
                                    setSelectedDialog(3);
                                    const body = {
                                      FirstPickupDate: values.first_pickup,
                                      InboundTransportGroupId:
                                        values.transport_InBound,
                                      InboundGateOutId:
                                        values.InBoundGateOut.LocationId,
                                      OutboundGateOutId:
                                        values.OutBoundGateOut.LocationId,
                                      ClosingDate: values.closing_date,
                                      ClosingTime: values.closing_time,
                                      ContainerTypeId: values.volume_container,
                                      Quantity: values.volume_quantity,
                                      CommodityId: values.commodity,
                                    };
                                    const getVoyIn = async () => {
                                      const res = await api.post(
                                        `api/saleorder/voy/inbound`,
                                        body
                                      );
                                      const data = await res.data;
                                      setVoyIn(data);
                                    };
                                    getVoyIn();
                                  }}
                                >
                                  search
                                </Button>
                              )}

                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              name="ETD_Gate_Out_Inbound_3"
                              label="ETD Gate Out"
                              value={values.ETD_Gate_Out_Inbound_3}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETD_Gate_Out_Inbound_3",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              name="ETA_Gate_In_Inbound_3"
                              label="ETA Gate IN"
                              value={values.ETA_Gate_In_Inbound_3}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue("ETA_Gate_In_Inbound_3", nformat);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <TextField
                              name="InboundQuantity_3"
                              label="InboundQuantity"
                              variant="outlined"
                              placeholder="Quantity"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                width: "20%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={values.InboundQuantity_3 || ""}
                            />
                            {values.voyIn_3 && (
                              <Button
                                color="error"
                                variant="contained"
                                onClick={() => {
                                  setFieldValue("voyIn_3", "");
                                  setFieldValue("ETA_Gate_In_Inbound_3", null);
                                  setFieldValue("ETD_Gate_Out_Inbound_3", null);
                                  setFieldValue("InboundQuantity_3", "");
                                }}
                              >
                                clear
                              </Button>
                            )}
                          </div>
                        </>
                      )}

                      <Dialog
                        fullWidth
                        maxWidth="lg"
                        open={openVoyIn}
                        onClose={() => setOpenVoyIn(false)}
                      >
                        <DialogTitle>Transportation Inbound</DialogTitle>
                        <DialogContent>
                          <Box sx={{ height: 400, width: "100%" }}>
                            <DataGrid
                              getRowId={(r) => r.VoyageScheduleId}
                              rows={voyIn?.map((x) => ({
                                ...x,
                                NewETDLocationFrom: moment(
                                  x?.ETDLocationFrom
                                ).format("DD/MM/yyyy h:mm"),
                                NewETALocationTo: moment(
                                  x?.ETALocationTo
                                ).format("DD/MM/yyyy  h:mm"),
                              }))}
                              columns={[
                                {
                                  field: "VoyNo",
                                  headerName: "Voy No",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "NewETDLocationFrom",
                                  headerName: "ETD",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "NewETALocationTo",
                                  headerName: "ETA",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "Remark",
                                  headerName: "Remark",
                                  width: 400,
                                  editable: true,
                                },
                                {
                                  headerName: "Action",
                                  width: 110,
                                  editable: true,
                                  renderCell: (params) => {
                                    return (
                                      <>
                                        <Button
                                          variant="contained"
                                          style={{
                                            textTransform: "none",
                                            backgroundColor: "#007BFF",
                                          }}
                                          onClick={() => {
                                            if (selectDialog === 1) {
                                              setFieldValue(
                                                "voyIn",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_Inbound",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_Inbound",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyIn(false);
                                              setSelectedDialog();
                                            } else if (selectDialog === 2) {
                                              setFieldValue(
                                                "voyIn_2",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_Inbound_2",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_Inbound_2",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyIn(false);
                                              setSelectedDialog();
                                            } else if (selectDialog === 3) {
                                              setFieldValue(
                                                "voyIn_3",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_Inbound_3",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_Inbound_3",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyIn(false);
                                              setSelectedDialog();
                                            }
                                          }}
                                        >
                                          select
                                        </Button>
                                      </>
                                    );
                                  },
                                },
                              ]}
                              disableSelectionOnClick
                              hideFooter={true}
                              disableColumnFilter
                              disableColumnMenu
                              experimentalFeatures={{ newEditingApi: true }}
                            />
                          </Box>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setOpenVoyIn(false);
                              setSelectedDialog();
                            }}
                          >
                            Cancel
                          </Button>
                        </DialogActions>
                      </Dialog>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Truck Plan
                      </h6>
                      <div style={{ marginTop: 10 }}>
                        <TableContainer>
                          <Table>
                            <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                              <TableRow>
                                <TableCell sx={{ width: "20%" }}>
                                  Request Truck
                                </TableCell>
                                <TableCell sx={{ width: "40%" }}>
                                  Vender
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Number of Trucks
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <FormControl
                                    size="small"
                                    sx={{ width: "100%", mr: "5px" }}
                                  >
                                    <InputLabel>Request</InputLabel>
                                    <Select
                                      name="container_gender_Inbound"
                                      label="Request"
                                      value={addTruck}
                                      // InputLabelProps={{ shrink: true }}
                                      onChange={(e) =>
                                        setAddTruck(e.target.value)
                                      }
                                    >
                                      <MenuItem value={1}>Yes</MenuItem>
                                      <MenuItem value={0}>No</MenuItem>
                                    </Select>
                                  </FormControl>
                                </TableCell>
                                <TableCell>
                                  <FormControl
                                    size="small"
                                    sx={{ width: "100%", mr: "5px" }}
                                  >
                                    <InputLabel>Vender</InputLabel>
                                    <Select
                                      label="Vender"
                                      value={addVender}
                                      onChange={(e) =>
                                        setAddVender(e.target.value)
                                      }
                                    >
                                      {venderData
                                        ?.filter(
                                          (y) =>
                                            rowMTCACS?.find(
                                              (z) => z?.Vender === y?.VenderName
                                            )?.Vender !== y?.VenderName
                                        )
                                        .map((x, i) => (
                                          <MenuItem
                                            key={i}
                                            value={x?.VenderName}
                                          >
                                            {x?.VenderName}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormControl>
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    label="Trucks"
                                    name="NumberOfTrucks"
                                    value={numberOfTrucks}
                                    onChange={(e) =>
                                      setNumberOfTrucks(e.target.value)
                                    }
                                    size="small"
                                    sx={{
                                      width: "100%",
                                      marginRight: "5px",
                                      "& .MuiInputBase-input": {},
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button
                                    variant="contained"
                                    disabled={
                                      addTruck && addVender ? false : true
                                    }
                                    size="small"
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "#80c340",
                                      marginBottom: "10px",
                                      "&:hover": {
                                        backgroundColor: "#80c340",
                                      },
                                    }}
                                    onClick={() => {
                                      setRowMTCACS([
                                        ...rowMTCACS,
                                        {
                                          id: rowMTCACS.slice(-1)[0]?.id
                                            ? rowMTCACS.slice(-1)[0]?.id + 1
                                            : 1,
                                          Truck: addTruck,
                                          Vender: addVender,
                                          NumberOfTrucks: numberOfTrucks,
                                        },
                                      ]);
                                      setAddTruck("");
                                      setAddVender("");
                                      setNumberOfTrucks("");
                                    }}
                                  >
                                    Add Row
                                  </Button>
                                </TableCell>
                              </TableRow>
                              {rowMTCACS?.map((x, i) => (
                                <TableRow>
                                  <TableCell>
                                    {" "}
                                    {isEdit.status && isEdit.id === x?.id ? (
                                      <FormControl
                                        size="small"
                                        sx={{ width: "100%", mr: "5px" }}
                                      >
                                        <InputLabel>Request</InputLabel>
                                        <Select
                                          name="container_gender_Inbound"
                                          label="Request"
                                          value={editTruck}
                                          InputLabelProps={{ shrink: true }}
                                          onChange={(e) =>
                                            setEditTruck(e.target.value)
                                          }
                                        >
                                          <MenuItem value={true}>Yes</MenuItem>
                                          <MenuItem value={false}>No</MenuItem>
                                        </Select>
                                      </FormControl>
                                    ) : (
                                      <FormControl
                                        size="small"
                                        sx={{ width: "100%", mr: "5px" }}
                                      >
                                        <InputLabel>Request</InputLabel>
                                        <Select
                                          disabled
                                          name="container_gender_Inbound"
                                          label="Request"
                                          value={x?.Truck || ""}
                                          InputLabelProps={{ shrink: true }}
                                        >
                                          <MenuItem value={true}>Yes</MenuItem>
                                          <MenuItem value={false}>No</MenuItem>
                                        </Select>
                                      </FormControl>
                                    )}
                                  </TableCell>

                                  <TableCell>
                                    {isEdit.status && isEdit.id === i + 1 ? (
                                      <FormControl
                                        size="small"
                                        sx={{ width: "100%", mr: "5px" }}
                                      >
                                        <InputLabel>Vender</InputLabel>
                                        <Select
                                          label="Vender"
                                          value={editVender}
                                          onChange={(e) =>
                                            setEditVender(e.target.value)
                                          }
                                        >
                                          {venderData?.map((x, i) => (
                                            <MenuItem
                                              key={i}
                                              disabled={
                                                rowMTCACS?.find(
                                                  (z) =>
                                                    z?.Vender === x?.VenderName
                                                )
                                                  ? true
                                                  : false
                                              }
                                              value={x?.VenderName}
                                            >
                                              {x?.VenderName}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    ) : (
                                      <TextField
                                        size="small"
                                        disabled
                                        label="Vender"
                                        value={x?.Vender}
                                        sx={{
                                          width: "100%",
                                          marginRight: "5px",
                                          "& .MuiInputBase-input": {},
                                        }}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {isEdit.status && isEdit.id === i + 1 ? (
                                      <TextField
                                        label="Trucks"
                                        name="NumberOfTrucks"
                                        value={editNumberOfTrucks}
                                        onChange={(e) =>
                                          setEditNumberOfTrucks(e.target.value)
                                        }
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          marginRight: "5px",
                                          "& .MuiInputBase-input": {},
                                        }}
                                      />
                                    ) : (
                                      <TextField
                                        label="Trucks"
                                        name="NumberOfTrucks"
                                        disabled
                                        value={x?.NumberOfTrucks}
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          marginRight: "5px",
                                          "& .MuiInputBase-input": {},
                                        }}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell sx={{ display: "flex" }}>
                                    {isEdit.status && isEdit.id === i + 1 ? (
                                      <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#80c340",
                                          marginRight: "10px",
                                          marginBottom: "10px",
                                          "&:hover": {
                                            backgroundColor: "#80c340",
                                          },
                                        }}
                                        onClick={() => {
                                          const data = rowMTCACS?.map((n) => {
                                            n.Vender =
                                              n?.id === x?.id
                                                ? editVender
                                                : n?.Vender;
                                            n.Truck =
                                              n?.id === x?.id
                                                ? editTruck
                                                : n?.Truck;
                                            n.NumberOfTrucks =
                                              n?.id === x?.id
                                                ? editNumberOfTrucks
                                                : n?.NumberOfTrucks;
                                            return n;
                                          });
                                          setRowMTCACS([...data]);
                                          setIsEdit({
                                            status: false,
                                            id: null,
                                          });
                                        }}
                                      >
                                        save
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#80c340",
                                          marginRight: "10px",
                                          marginBottom: "10px",
                                          "&:hover": {
                                            backgroundColor: "#80c340",
                                          },
                                        }}
                                        onClick={() => {
                                          setEditTruck(x?.Truck);
                                          setEditVender(x?.Vender);
                                          setEditNumberOfTrucks(
                                            x?.NumberOfTrucks
                                          );
                                          setIsEdit({
                                            status: true,
                                            id: x?.id,
                                          });
                                        }}
                                      >
                                        edit
                                      </Button>
                                    )}

                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "red",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "red",
                                        },
                                      }}
                                      onClick={() => {
                                        const data = rowMTCACS?.filter(
                                          (y) => y?.id !== x?.id
                                        );
                                        setRowMTCACS(data);
                                        setIsEdit({ status: false, id: null });
                                      }}
                                    >
                                      delete
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Stuffing Plan
                      </h6>
                      <div style={{ marginTop: 10 }}>
                        <TableContainer>
                          <Table>
                            <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                              <TableRow>
                                <TableCell sx={{ width: "20%" }}>
                                  Pick-up Date
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Factory
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Return Date
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Quantity
                                </TableCell>
                                <TableCell sx={{ width: "20%" }}>
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <DesktopDatePicker
                                    inputFormat="dd/MM/yyyy"
                                    label="Pick-up Date"
                                    value={addPUD}
                                    onChange={(e) => setAddPUD(e)}
                                    renderInput={(params) => (
                                      <TextField
                                        size="small"
                                        style={{
                                          width: "100%",
                                          marginRight: 5,
                                        }}
                                        {...params}
                                      />
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Autocomplete
                                    size="small"
                                    options={factoryData}
                                    getOptionLabel={(option) =>
                                      option?.FactoryName
                                    }
                                    id="flat-demo"
                                    sx={{ width: "100%", mr: "5px" }}
                                    value={addFactory}
                                    onChange={(event, newValue) => {
                                      setAddFactory(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} label="Factory" />
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <DesktopDatePicker
                                    inputFormat="dd/MM/yyyy"
                                    value={addRD}
                                    onChange={(e) => setAddRD(e)}
                                    label="Return Date"
                                    renderInput={(params) => (
                                      <TextField
                                        size="small"
                                        style={{
                                          width: "100%",
                                          marginRight: 5,
                                        }}
                                        {...params}
                                      />
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    label="Quantity"
                                    name=""
                                    value={addQTT || null}
                                    onChange={(e) => {
                                      setAddQTT(e.target.value);
                                    }}
                                    size="small"
                                    sx={{
                                      width: "100%",
                                      marginRight: "5px",
                                      "& .MuiInputBase-input": {},
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    disabled={
                                      addFactory && addPUD && addRD && addQTT
                                        ? false
                                        : true
                                    }
                                    sx={{
                                      width: "100%",
                                      backgroundColor: "#80c340",
                                      marginBottom: "10px",
                                      "&:hover": {
                                        backgroundColor: "#80c340",
                                      },
                                    }}
                                    onClick={() => {
                                      setRowStuffing([
                                        ...rowStuffing,
                                        {
                                          id: rowStuffing.slice(-1)[0]?.id
                                            ? rowStuffing.slice(-1)[0]?.id + 1
                                            : 1,
                                          Factory: addFactory,
                                          PUD: addPUD,
                                          RD: addRD,
                                          QTT: addQTT,
                                        },
                                      ]);
                                      setAddFactory(null);
                                      setAddPUD(null);
                                      setAddRD(null);
                                      setAddQTT(null);
                                    }}
                                  >
                                    Add Row
                                  </Button>
                                </TableCell>
                              </TableRow>
                              {rowStuffing?.map((x, i) => (
                                <TableRow>
                                  <TableCell>
                                    {" "}
                                    {isEditS.status && isEditS.id === x?.id ? (
                                      <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        value={editPUD}
                                        onChange={(e) => setEditPUD(e)}
                                        label="Pick-up Date"
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            style={{
                                              width: "100%",
                                              marginRight: 5,
                                            }}
                                            {...params}
                                          />
                                        )}
                                      />
                                    ) : (
                                      <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        disabled
                                        value={x?.PUD}
                                        label="Pick-up Date"
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            style={{
                                              width: "100%",
                                              marginRight: 5,
                                            }}
                                            {...params}
                                          />
                                        )}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {isEditS.status && isEditS.id === x?.id ? (
                                      <Autocomplete
                                        size="small"
                                        options={factoryData}
                                        getOptionLabel={(option) =>
                                          option?.FactoryName
                                        }
                                        id="flat-demo"
                                        sx={{ width: "100%", mr: "5px" }}
                                        value={editFactory}
                                        onChange={(event, newValue) => {
                                          setEditFactory(newValue);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Factory"
                                          />
                                        )}
                                      />
                                    ) : (
                                      <Autocomplete
                                        size="small"
                                        options={factoryData}
                                        getOptionLabel={(option) =>
                                          option?.FactoryName
                                        }
                                        id="flat-demo"
                                        sx={{ width: "100%", mr: "5px" }}
                                        value={x?.Factory}
                                        disabled
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Factory"
                                          />
                                        )}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {isEditS.status && isEditS.id === x?.id ? (
                                      <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        value={editRD}
                                        onChange={(e) => setEditRD(e)}
                                        label="Return Date"
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            style={{
                                              width: "100%",
                                              marginRight: 5,
                                            }}
                                            {...params}
                                          />
                                        )}
                                      />
                                    ) : (
                                      <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        disabled
                                        value={x?.RD}
                                        label="Return Date"
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            style={{
                                              width: "100%",
                                              marginRight: 5,
                                            }}
                                            {...params}
                                          />
                                        )}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {isEditS.status && isEditS.id === x?.id ? (
                                      <TextField
                                        label="Quantity"
                                        name=""
                                        value={editQTT}
                                        onChange={(e) => {
                                          setEditQTT(e.target.value);
                                        }}
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          marginRight: "5px",
                                          "& .MuiInputBase-input": {},
                                        }}
                                      />
                                    ) : (
                                      <TextField
                                        label="Quantity"
                                        name=""
                                        disabled={true}
                                        value={x?.QTT}
                                        onChange={(e) => {}}
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          marginRight: "5px",
                                          "& .MuiInputBase-input": {},
                                        }}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell sx={{ display: "flex" }}>
                                    {isEditS.status && isEditS.id === x?.id ? (
                                      <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#80c340",
                                          marginRight: "10px",
                                          marginBottom: "10px",
                                          "&:hover": {
                                            backgroundColor: "#80c340",
                                          },
                                        }}
                                        onClick={() => {
                                          const data = rowStuffing?.map((n) => {
                                            n.PUD =
                                              n?.id === x?.id
                                                ? editPUD
                                                : n?.PUD;
                                            n.RD =
                                              n?.id === x?.id ? editRD : n?.RD;
                                            n.Factory =
                                              n?.id === x?.id
                                                ? editFactory
                                                : n?.Factory;
                                            n.QTT =
                                              n?.id === x?.id
                                                ? editQTT
                                                : n?.QTT;
                                            return n;
                                          });
                                          setRowStuffing([...data]);
                                          setIsEditS({
                                            status: false,
                                            id: null,
                                          });
                                        }}
                                      >
                                        save
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          width: "100%",
                                          backgroundColor: "#80c340",
                                          marginRight: "10px",
                                          marginBottom: "10px",
                                          "&:hover": {
                                            backgroundColor: "#80c340",
                                          },
                                        }}
                                        onClick={() => {
                                          setEditFactory(x?.Factory);
                                          setEditPUD(x?.PUD);
                                          setEditRD(x?.RD);
                                          setEditQTT(x?.QTT);
                                          setIsEditS({
                                            status: true,
                                            id: x?.id,
                                          });
                                        }}
                                      >
                                        edit
                                      </Button>
                                    )}

                                    <Button
                                      variant="contained"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                        backgroundColor: "red",
                                        marginBottom: "10px",
                                        "&:hover": {
                                          backgroundColor: "red",
                                        },
                                      }}
                                      onClick={() => {
                                        const data = rowStuffing?.filter(
                                          (y) => y?.id !== x?.id
                                        );
                                        setRowStuffing(data);
                                      }}
                                    >
                                      delete
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                      </>
                      )}
                      {/* ซ่อน Outbound block เมื่อเป็นงาน One-Way / Import (จบที่โรงงาน) */}
                      {!(values.TripType === "One-Way" && values.TripDirection === "Import") && (
                      <>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Transportation Outbound
                      </h6>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <FormControl
                          sx={{ width: "30%", mr: "5px" }}
                          classes={{
                            root: !values.transport_OutBound
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <InputLabel>Transport</InputLabel>
                          <Select
                            name="transport_OutBound"
                            label="Transport"
                            value={values.transport_OutBound}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setFieldValue(
                                "transport_OutBound",
                                e.target.value
                              );
                              setFieldValue("voyOut", "");
                              setFieldValue("ETA_Gate_In_OutBound", null);
                              setFieldValue("ETD_Gate_Out_OutBound", null);
                            }}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="" disabled>
                              <em>เลือก ประเภทการขนส่ง </em>
                            </MenuItem>
                            {groupData.map((option, index) => {
                              return (
                                <MenuItem key={index} value={option?.GroupId}>
                                  {option?.GroupName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <Autocomplete
                          options={locationData}
                          getOptionLabel={(option) => option?.LocationName}
                          onChange={(event, newValue) => {
                            setFieldValue("OutBoundGateOut", newValue);
                          }}
                          classes={{
                            root: !values.OutBoundGateOut
                              ? classes.customOutline
                              : null,
                          }}
                          required
                          value={
                            values.OutBoundGateOut
                              ? values.OutBoundGateOut
                              : null
                          }
                          id="flat-demo"
                          sx={{ width: "40%", mr: "5px" }}
                          renderInput={(params) => (
                            <TextField {...params} label="Gate Out" />
                          )}
                        />
                        <FormControl
                          sx={{ width: "30%", mr: "5px" }}
                          classes={{
                            root: !values.container_gender_OutBound
                              ? classes.customOutline
                              : null,
                          }}
                          required
                        >
                          <InputLabel>Container Gender</InputLabel>
                          <Select
                            name="container_gender_OutBound"
                            label="Empty / Laden"
                            value={values.container_gender_OutBound}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value="Empty">Empty</MenuItem>
                            <MenuItem value="Laden">Laden</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Return Laden Container
                      </h6>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="first_Laden_Date"
                          label="1ST Laden Date"
                          variant="outlined"
                          placeholder="1ST Laden Date"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          readOnly
                          style={{ width: "30%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ readOnly: true }}
                          value={
                            values.first_Laden_Date
                              ? moment(values.first_Laden_Date).format(
                                  "DD/MM/yyyy"
                                )
                              : null
                          }
                        />

                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          name="actual_Laden_Date"
                          label="Actual Date"
                          value={values.actual_Laden_Date}
                          onChange={(e) => {
                            const nformat = moment(e).format("YYYY-MM-DD");
                            setFieldValue("actual_Laden_Date", nformat);
                            // setFieldValue("first_pickup", SUM_FREETIME(e.target.value + '_PE', values.etd_pol, values.closing_date, values.first_pickup, values.actual_pickup, values.det, values.dem, e.target.value))
                            if (values.com) {
                              const pickup_Date = SUM_FREETIME(
                                values.CountingType + "_PE",
                                values.etd_pol,
                                values.closing_date,
                                values.first_pickup,
                                nformat,
                                values.det,
                                values.dem,
                                values.com
                              );
                              if (pickup_Date) {
                                setFieldValue("first_pickup", pickup_Date);
                              }
                            } else {
                              const pickup_Date = SUM_FREETIME(
                                values.CountingType + "_DET",
                                values.etd_pol,
                                values.closing_date,
                                values.first_pickup,
                                nformat,
                                values.det,
                                values.dem,
                                values.com
                              );
                              if (pickup_Date) {
                                setFieldValue("first_pickup", pickup_Date);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "30%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        {values.actual_Laden_Date && values.first_Laden_Date ? (
                          <TextField
                            label="diff"
                            value={Math.round(
                              (new Date(values.actual_Laden_Date) -
                                new Date(values.first_Laden_Date)) /
                                1000 /
                                60 /
                                60 /
                                24
                            )}
                            sx={{
                              marginRight: "5px",
                              "& .MuiInputBase-input": {
                                color:
                                  Math.round(
                                    // Math.abs(
                                    (new Date(values.actual_Laden_Date) -
                                      new Date(values.first_Laden_Date)) /
                                      // )
                                      1000 /
                                      60 /
                                      60 /
                                      24
                                  ) >= 0
                                    ? "#000"
                                    : "red",
                              },
                            }}
                          />
                        ) : (
                          ""
                        )}
                        {/* <FormControl style={{ width: "30%" }}>
                          <InputLabel>Terminal</InputLabel>
                          <Select
                            name="TerminalId"
                            label="Terminal"
                            value={values.TerminalId}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            MenuProps={{
                              style: {
                                maxHeight: 400,
                              },
                            }}
                          // disabled={values.inco_terms ? true : false}
                          >

                            {terminalsData.map((option, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={option?.TerminalId}
                                >
                                  {option?.TerminalName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl> */}
                        <Autocomplete
                          name="TerminalName"
                          options={terminalsListData}
                          getOptionLabel={(option) => option?.TerminalName}
                          onChange={(x, y) => {
                            setFieldValue("TerminalName", y);
                          }}
                          id="flat-demo"
                          value={values.TerminalName}
                          sx={{ width: "30%", mr: "5px" }}
                          renderInput={(params) => (
                            <TextField {...params} label="Terminal" />
                          )}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          label="Voy Out"
                          name="voyOut"
                          value={values.voyOut}
                          InputLabelProps={{ shrink: true }}
                          onBlur={handleBlur}
                          sx={{
                            width: "40%",
                            marginRight: "5px",
                            "& .MuiInputBase-input": {},
                          }}
                        />
                        {values.first_Laden_Date &&
                          values.transport_OutBound &&
                          values.OutBoundGateOut && (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setOpenVoyOut(true);
                                setSelectedDialog(1);
                                const body = {
                                  FirstLadenDate: values.first_Laden_Date,
                                  OutboundTransportGroupId:
                                    values.transport_OutBound,
                                  InboundGateOutId:
                                    values.InBoundGateOut.LocationId,
                                  OutboundGateOutId:
                                    values.OutBoundGateOut.LocationId,
                                  ClosingDate: values.closing_date,
                                  ClosingTime: values.closing_time,
                                  ContainerTypeId: values.volume_container,
                                  Quantity: values.volume_quantity,
                                  CommodityId: values.commodity,
                                };
                                const getVoyOut = async () => {
                                  const res = await api.post(
                                    `api/saleorder/voy/outbound`,
                                    body
                                  );
                                  const data = await res.data;
                                  setVoyOut(data);
                                };
                                getVoyOut();
                              }}
                            >
                              search
                            </Button>
                          )}

                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          // name="actual_pickup"
                          label="ETD Gate Out"
                          name="ETD_Gate_Out_OutBound"
                          value={values.ETD_Gate_Out_OutBound}
                          onChange={(e) => {
                            const nformat = moment(e).format("yyyy-MM-DD");
                            setFieldValue("ETD_Gate_Out_OutBound", nformat);
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "30%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        <DesktopDatePicker
                          inputFormat="dd/MM/yyyy"
                          // name="actual_pickup"
                          label="ETA Gate IN"
                          name="ETA_Gate_In_OutBound"
                          value={values.ETA_Gate_In_OutBound}
                          onChange={(e) => {
                            const nformat = moment(e).format("yyyy-MM-DD");
                            setFieldValue("ETA_Gate_In_OutBound", nformat);
                          }}
                          renderInput={(params) => (
                            <TextField
                              style={{
                                width: "30%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              {...params}
                            />
                          )}
                        />
                        {values.transport_OutBound === "G002" && (
                          <TextField
                            name="OutboundQuantity"
                            label="OutboundQuantity"
                            variant="outlined"
                            placeholder="Quantity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            style={{
                              width: "20%",
                              marginRight: 5,
                              marginLeft: 5,
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={values.OutboundQuantity || ""}
                          />
                        )}
                        {values.voyOut && (
                          <Button
                            color="error"
                            variant="contained"
                            onClick={() => {
                              setFieldValue("voyOut", "");
                              setFieldValue("ETA_Gate_In_OutBound", null);
                              setFieldValue("ETD_Gate_Out_OutBound", null);
                              setFieldValue("OutboundQuantity", "");
                            }}
                          >
                            clear
                          </Button>
                        )}
                      </div>
                      {values.transport_OutBound === "G002" && (
                        <>
                          <div style={{ display: "flex", marginTop: 10 }}>
                            <TextField
                              label="Voy Out"
                              name="voyOut_2"
                              value={values.voyOut_2}
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              sx={{
                                width: "40%",
                                marginRight: "5px",
                                "& .MuiInputBase-input": {},
                              }}
                            />
                            {values.first_Laden_Date &&
                              values.transport_OutBound &&
                              values.OutBoundGateOut && (
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    setOpenVoyOut(true);
                                    setSelectedDialog(2);
                                    const body = {
                                      FirstLadenDate: values.first_Laden_Date,
                                      OutboundTransportGroupId:
                                        values.transport_OutBound,
                                      InboundGateOutId:
                                        values.InBoundGateOut.LocationId,
                                      OutboundGateOutId:
                                        values.OutBoundGateOut.LocationId,
                                      ClosingDate: values.closing_date,
                                      ClosingTime: values.closing_time,
                                      ContainerTypeId: values.volume_container,
                                      Quantity: values.volume_quantity,
                                      CommodityId: values.commodity,
                                    };
                                    const getVoyOut = async () => {
                                      const res = await api.post(
                                        `api/saleorder/voy/outbound`,
                                        body
                                      );
                                      const data = await res.data;
                                      setVoyOut(data);
                                    };
                                    getVoyOut();
                                  }}
                                >
                                  search
                                </Button>
                              )}

                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              // name="actual_pickup"
                              label="ETD Gate Out"
                              name="ETD_Gate_Out_OutBound_2"
                              value={values.ETD_Gate_Out_OutBound_2}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETD_Gate_Out_OutBound_2",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              // name="actual_pickup"
                              label="ETA Gate IN"
                              name="ETA_Gate_In_OutBound_2"
                              value={values.ETA_Gate_In_OutBound_2}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETA_Gate_In_OutBound_2",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <TextField
                              name="OutboundQuantity_2"
                              label="OutboundQuantity"
                              variant="outlined"
                              placeholder="Quantity"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                width: "20%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={values.OutboundQuantity_2 || ""}
                            />
                            {values.voyOut_2 && (
                              <Button
                                color="error"
                                variant="contained"
                                onClick={() => {
                                  setFieldValue("voyOut_2", "");
                                  setFieldValue("ETA_Gate_In_OutBound_2", null);
                                  setFieldValue(
                                    "ETD_Gate_Out_OutBound_2",
                                    null
                                  );
                                  setFieldValue("OutboundQuantity_2", "");
                                }}
                              >
                                clear
                              </Button>
                            )}
                          </div>
                          <div style={{ display: "flex", marginTop: 10 }}>
                            <TextField
                              label="Voy Out"
                              name="voyOut_3"
                              value={values.voyOut_3}
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              sx={{
                                width: "40%",
                                marginRight: "5px",
                                "& .MuiInputBase-input": {},
                              }}
                            />
                            {values.first_Laden_Date &&
                              values.transport_OutBound &&
                              values.OutBoundGateOut && (
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    setOpenVoyOut(true);
                                    setSelectedDialog(3);
                                    const body = {
                                      FirstLadenDate: values.first_Laden_Date,
                                      OutboundTransportGroupId:
                                        values.transport_OutBound,
                                      InboundGateOutId:
                                        values.InBoundGateOut.LocationId,
                                      OutboundGateOutId:
                                        values.OutBoundGateOut.LocationId,
                                      ClosingDate: values.closing_date,
                                      ClosingTime: values.closing_time,
                                      ContainerTypeId: values.volume_container,
                                      Quantity: values.volume_quantity,
                                      CommodityId: values.commodity,
                                    };
                                    const getVoyOut = async () => {
                                      const res = await api.post(
                                        `api/saleorder/voy/outbound`,
                                        body
                                      );
                                      const data = await res.data;
                                      setVoyOut(data);
                                    };
                                    getVoyOut();
                                  }}
                                >
                                  search
                                </Button>
                              )}

                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              // name="actual_pickup"
                              label="ETD Gate Out"
                              name="ETD_Gate_Out_OutBound_3"
                              value={values.ETD_Gate_Out_OutBound_3}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETD_Gate_Out_OutBound_3",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <DesktopDatePicker
                              inputFormat="dd/MM/yyyy"
                              // name="actual_pickup"
                              label="ETA Gate IN"
                              name="ETA_Gate_In_OutBound_3"
                              value={values.ETA_Gate_In_OutBound_3}
                              onChange={(e) => {
                                const nformat = moment(e).format("yyyy-MM-DD");
                                setFieldValue(
                                  "ETA_Gate_In_OutBound_3",
                                  nformat
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  style={{
                                    width: "30%",
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                  {...params}
                                />
                              )}
                            />
                            <TextField
                              name="OutboundQuantity_3"
                              label="OutboundQuantity"
                              variant="outlined"
                              placeholder="Quantity"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                width: "20%",
                                marginRight: 5,
                                marginLeft: 5,
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={values.OutboundQuantity_3 || ""}
                            />
                            {values.voyOut_3 && (
                              <Button
                                color="error"
                                variant="contained"
                                onClick={() => {
                                  setFieldValue("voyOut_3", "");
                                  setFieldValue("ETA_Gate_In_OutBound_3", null);
                                  setFieldValue(
                                    "ETD_Gate_Out_OutBound_3",
                                    null
                                  );
                                  setFieldValue("OutboundQuantity_3", "");
                                }}
                              >
                                clear
                              </Button>
                            )}
                          </div>
                        </>
                      )}
                      <Dialog
                        fullWidth
                        maxWidth="lg"
                        open={openVoyOut}
                        onClose={() => setOpenVoyOut(false)}
                      >
                        <DialogTitle>Transportation Outbound</DialogTitle>
                        <DialogContent>
                          <Box sx={{ height: 400, width: "100%" }}>
                            <DataGrid
                              getRowId={(r) => r.VoyageScheduleId}
                              rows={voyOut?.map((x) => ({
                                ...x,
                                NewETDLocationFrom: moment(
                                  x?.ETDLocationFrom
                                ).format("DD/MM/yyyy h:mm"),
                                NewETALocationTo: moment(
                                  x?.ETALocationTo
                                ).format("DD/MM/yyyy  h:mm"),
                              }))}
                              columns={[
                                {
                                  field: "VoyNo",
                                  headerName: "Voy No",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "NewETDLocationFrom",
                                  headerName: "ETD",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "NewETALocationTo",
                                  headerName: "ETA",
                                  width: 200,
                                  editable: true,
                                },
                                {
                                  field: "Remark",
                                  headerName: "Remark",
                                  width: 400,
                                  editable: true,
                                },
                                {
                                  headerName: "Action",
                                  width: 110,
                                  editable: true,
                                  renderCell: (params) => {
                                    return (
                                      <>
                                        <Button
                                          variant="contained"
                                          style={{
                                            textTransform: "none",
                                            backgroundColor: "#007BFF",
                                          }}
                                          onClick={() => {
                                            if (selectDialog === 1) {
                                              setFieldValue(
                                                "voyOut",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_OutBound",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_OutBound",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyOut(false);
                                              setSelectedDialog();
                                            } else if (selectDialog === 2) {
                                              setFieldValue(
                                                "voyOut_2",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_OutBound_2",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_OutBound_2",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyOut(false);
                                              setSelectedDialog();
                                            } else if (selectDialog === 3) {
                                              setFieldValue(
                                                "voyOut_3",
                                                params.row.VoyNo
                                              );
                                              setFieldValue(
                                                "ETA_Gate_In_OutBound_3",
                                                moment(
                                                  params.row.ETALocationTo
                                                ).format("yyyy-MM-DD")
                                              );
                                              setFieldValue(
                                                "ETD_Gate_Out_OutBound_3",
                                                moment(
                                                  params.row.ETDLocationFrom
                                                ).format("yyyy-MM-DD")
                                              );
                                              setOpenVoyOut(false);
                                              setSelectedDialog();
                                            }
                                          }}
                                        >
                                          select
                                        </Button>
                                      </>
                                    );
                                  },
                                },
                              ]}
                              disableSelectionOnClick
                              hideFooter={true}
                              disableColumnFilter
                              disableColumnMenu
                              experimentalFeatures={{ newEditingApi: true }}
                            />
                          </Box>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                              setOpenVoyOut(false);
                              setSelectedDialog();
                            }}
                          >
                            Cancel
                          </Button>
                        </DialogActions>
                      </Dialog>
                      </>
                      )}
                      <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Phyto
                      </h6>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <FormControl sx={{ width: "10%", mr: "5px" }}>
                          <InputLabel>PHYTO CERT</InputLabel>
                          <Select
                            name="phyto_cert"
                            label="PHYTO CERT"
                            value={values.phyto_cert}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl sx={{ width: "25%", mr: "5px" }}>
                          <InputLabel>Inspection Station</InputLabel>
                          <Select
                            name="PhytoCertInspectionStaionId"
                            label="Inspection Station"
                            value={values.PhytoCertInspectionStaionId}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={values.phyto_cert !== true ? true : false}
                          >
                            {inspectionStationData?.map((item, i) => {
                              return (
                                <MenuItem value={item?.InspectionStationId}>
                                  {item?.InspectionStationName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <TextField
                          name="phyto_cert_remark"
                          label="PHYTO CERT Remark"
                          variant="outlined"
                          disabled={values.phyto_cert !== true ? true : false}
                          placeholder="PHYTO CERT Remark"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={values.phyto_cert_remark}
                          sx={{ width: "65%" }}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <FormControl sx={{ width: "10%", mr: "5px" }}>
                          <InputLabel>FUMIGATION</InputLabel>
                          <Select
                            name="fumigation"
                            label="FUMIGATION"
                            value={values.fumigation}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          sx={{ width: "25%", mr: "5px", marginRight: "5px" }}
                        >
                          <InputLabel>Inspection Station</InputLabel>
                          <Select
                            name="FumigationInspectionStaionId"
                            label="Inspection Station"
                            value={values.FumigationInspectionStaionId}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={values.fumigation !== true ? true : false}
                          >
                            {inspectionStationData?.map((item, i) => {
                              return (
                                <MenuItem value={item?.InspectionStationId}>
                                  {item?.InspectionStationName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <TextField
                          name="FumigationPQNo"
                          label="FumigationPQ No"
                          variant="outlined"
                          disabled={values.fumigation !== true ? true : false}
                          placeholder="FumigationPQ No"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={values.FumigationPQNo}
                          sx={{ width: "25%", mr: "5px" }}
                        />
                        <TextField
                          name="fumigation_remark"
                          label="FUMIGATION Remark"
                          variant="outlined"
                          disabled={values.fumigation !== true ? true : false}
                          placeholder="FUMIGATION Remark"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          value={values.fumigation_remark}
                          sx={{ width: "40%" }}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <div style={{ display: "flex", marginTop: 10 }}>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    back
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <CircularProgress size={22} />}
                    {!isSubmitting && "SAVE"}
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </Card>
      </LocalizationProvider>
    </div>
  );
}
